import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Heart, Pill, Phone, MessageCircle, Mic, Keyboard, CheckCircle } from 'lucide-react'; 
import { supabase } from './supabase';
import './App.css';
import { CHARACTER_PROMPTS } from './characterPrompts';




function App() {
  // --- 状態管理 ---
  const [activeTab, setActiveTab] = useState('home');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [safetyChecks, setSafetyChecks] = useState([]);
  const [medications, setMedications] = useState([
    { id: 1, name: '朝の薬', time: '08:00', taken: false },
    { id: 2, name: '昼の薬', time: '12:00', taken: false },
    { id: 3, name: '夜の薬', time: '20:00', taken: false }
  ]);
  const [contacts] = useState([
    { id: 1, name: '家族(太郎)', phone: '090-1234-5678', relation: '息子' },
    { id: 2, name: 'かかりつけ医', phone: '0123-45-6789', relation: '医師' },
    { id: 3, name: '緊急連絡先', phone: '119', relation: '救急' }
  ]);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isLoading, setIsLoading] = useState(false);
  const [isListening, setIsListening] = useState(false);
  const [claudeMessage, setClaudeMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [showTextInput, setShowTextInput] = useState(false);
  const [textInput, setTextInput] = useState('');
   // --- Supabase users ---
  const [users, setUsers] = useState([]);
  const [currentUser, setCurrentUser] = useState(null);
const [parentData, setParentData] = useState(null);
const [parentSafetyCheck, setParentSafetyCheck] = useState(null);
const [parentMedications, setParentMedications] = useState([]);
const [safetyCheckHistory, setSafetyCheckHistory] = useState([]);
const [medicationHistory, setMedicationHistory] = useState([]);
const [registrationStep, setRegistrationStep] = useState('select'); // 'select', 'main', 'support'
const [registrationName, setRegistrationName] = useState('');
const [inviteCode, setInviteCode] = useState('');
const [showPlanChange, setShowPlanChange] = useState(false);
const [showInviteHistory, setShowInviteHistory] = useState(false);
const [invitedUsers, setInvitedUsers] = useState([]);
const [selectedCharacter, setSelectedCharacter] = useState('woman30'); 
const [currentAudio, setCurrentAudio] = useState(null);
const [postalCode, setPostalCode] = useState('');
const [prefecture, setPrefecture] = useState('');
const [city, setCity] = useState('');
const [emergencyTab, setEmergencyTab] = useState('contacts');
const [showEmergencyForm, setShowEmergencyForm] = useState(false);
const [emergencyContacts, setEmergencyContacts] = useState([]);
const [showRiddle, setShowRiddle] = useState(false);
const [riddleData, setRiddleData] = useState(null);
const [countdown, setCountdown] = useState(5);
const [showAnswer, setShowAnswer] = useState(false);
const [showTerms, setShowTerms] = useState(false);
const [showPrivacy, setShowPrivacy] = useState(false);
const [showTokuho, setShowTokuho] = useState(false); 
const [showTokuhoText, setShowTokuhoText] = useState(false);
const [micLevel, setMicLevel] = useState(0); // マイク音量レベル
const [showHomeAddGuide, setShowHomeAddGuide] = useState(false);
const [inviteCodeInput, setInviteCodeInput] = useState('');

// ✅ なぞなぞリスト（30個）
const RIDDLE_LIST = [
  { question: "パンはパンでも、食べられないパンは何でしょう？", answer: "フライパン" },
  { question: "いつも走っているのに、同じ場所にいるものは何でしょう？", answer: "時計の針" },
  { question: "上は洪水、下は大火事。これは何でしょう？", answer: "お風呂" },
  { question: "部屋にあるのに、部屋の外にあるものは何でしょう？", answer: "窓" },
  { question: "白くて丸くて、雨が降ると消えてしまうものは何でしょう？", answer: "雪だるま" },
  { question: "かけても、かけても、進まないものは何でしょう？", answer: "電話" },
  { question: "朝と夜があるのに、昼がないものは何でしょう？", answer: "新聞" },
  { question: "かけても、割れないものは何でしょう？", answer: "保険" },
  { question: "1つ買うと2つついてくるものは何でしょう？", answer: "箸" },
  { question: "耳はあっても、聞こえないものは何でしょう？", answer: "みみず" },
  { question: "口はあっても、話せないものは何でしょう？", answer: "瓶" },
  { question: "手はあっても、握れないものは何でしょう？", answer: "手紙" },
  { question: "足があっても、歩けないものは何でしょう？", answer: "テーブル" },
  { question: "夏でも寒いところはどこでしょう？", answer: "冷蔵庫の中" },
  { question: "どんなに走っても、追いつけないものは何でしょう？", answer: "影" },
  { question: "たたいても、叩いても、怒らないものは何でしょう？", answer: "太鼓" },
  { question: "切っても、切っても、切れないものは何でしょう？", answer: "水" },
  { question: "子供のときは大きくて、大人になると小さくなるものは何でしょう？", answer: "夢" },
  { question: "どこにでもあるのに、どこにも見えないものは何でしょう？", answer: "空気" },
  { question: "見えないのに、誰もが持っているものは何でしょう？", answer: "心" },
{ question: "買うときは黒いのに、使うと赤くなって、捨てるときは白くなるものは何でしょう？", answer: "炭" },
{ question: "月に一度、必ず会えるのに、触れないものは何でしょう？", answer: "満月" },
{ question: "一度失うと、二度と戻らないものは何でしょう？", answer: "時間" },
{ question: "持っていても、持っていないと言える唯一のものは何でしょう？", answer: "秘密" },
{ question: "誰もが毎日使うのに、誰も見たことがないものは何でしょう？", answer: "声" },
{ question: "世界中にあるのに、誰も持ち帰れないものは何でしょう？", answer: "空" },
{ question: "重いものより軽いものの方が、持ち上げるのが難しいものは何でしょう？", answer: "羽（羽毛）" },
{ question: "始まりがあって、終わりがないものは何でしょう？", answer: "円" }
];

// ✅ 会話・音声の安全な停止（iPhone対策 完全版）
const stopConversation = useCallback(() => {
  console.log('=== 会話停止 ===');

  // 音声認識停止
  if (recognitionRef.current) {
    try {
      recognitionRef.current.abort();
      recognitionRef.current.stop();
    } catch (e) {
      console.log('認識停止エラー:', e);
    }
  }
  
  // ✅ 強制的に状態をリセット
  setIsListening(false);

  // OpenAI TTS Audio 完全破棄
  if (currentAudio) {
    try {
      currentAudio.pause();
      currentAudio.src = "";
      currentAudio.load();
    } catch (e) {}
    setCurrentAudio(null);
  }

  // ブラウザ音声停止
  if ('speechSynthesis' in window) {
    window.speechSynthesis.cancel();
  }

  // DOM Audio 強制全破棄
  document.querySelectorAll("audio").forEach(a => {
    try {
      a.pause();
      a.src = "";
      a.load();
    } catch (e) {}
  });

  setIsLoading(false);
  setContinueConversation(false);
  setShowMessage(false);
}, [currentAudio]);

// ▼ iPhone / iPad / Safari / Fireタブレットの音声再生制限を解除する
const unlockIOSAudio = () => {
  const audio = new Audio(
    "data:audio/mp3;base64,//uQZAAAAAAAAAAAAAAAAAAAA"
  ); // 0.01秒の無音データ
  audio.play().catch(() => {});
};

      // ✅ 今日の利用回数を取得（IP制限付き）
const getTodayUsageCount = async () => {
  if (!currentUser) return 0;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  // ✅ IPアドレスを取得
  let ipAddress = 'unknown';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    console.log('解約レスポンス:', data);
console.log('cancel_at の値:', data.cancel_at);
console.log('cancel_at の型:', typeof data.cancel_at);
    ipAddress = data.ip;
  } catch (e) {
    console.error('IP取得エラー:', e);
  }

  // ✅ user_id OR ip_address でカウント
  const { data, error } = await supabase
    .from('usage_logs')
    .select('id')
    .or(`user_id.eq.${currentUser.id},ip_address.eq.${ipAddress}`)
    .gte('used_at', today.toISOString());

  if (error) {
    console.error('利用回数取得エラー:', error);
    return 0;
  }

  console.log(`利用回数: ${data?.length || 0} (IP: ${ipAddress})`);
  return data?.length || 0;
};
// ✅ 利用記録（IP保存）
const logUsage = async () => {
  if (!currentUser) return;

  // ✅ IPアドレスを取得
  let ipAddress = 'unknown';
  try {
    const response = await fetch('https://api.ipify.org?format=json');
    const data = await response.json();
    ipAddress = data.ip;
  } catch (e) {
    console.error('IP取得エラー:', e);
  }

  const { error } = await supabase
    .from('usage_logs')
    .insert([{ 
      user_id: currentUser.id,
      ip_address: ipAddress  // ✅ IPアドレスも保存
    }]);

  if (error) {
    console.error('利用記録エラー:', error);
  } else {
    console.log('利用記録完了:', { user_id: currentUser.id, ip: ipAddress });
  // ✅ 利用回数を再取得
    await fetchRemainingUses();
  }
};
// ✅ 利用制限チェック（開発者モード対応）
const checkUsageLimit = async () => {
  // ✅ 開発者は無制限
  if (currentUser?.is_developer) {
    console.log('🔧 開発者モード: 制限なし');
    return true;
  }

  const count = await getTodayUsageCount();
  let limit;
if (currentUser?.plan === 'free') {
  limit = 3;
} else if (currentUser?.plan === 'basic') {
  limit = 7;
} else if (currentUser?.plan === 'value') {
  limit = 15;
} else {
  limit = 3;
}

  console.log(`利用回数チェック: ${count}/${limit}`);

  if (count >= limit) {
    alert(
      `本日の利用回数上限（${limit}回）に達しました。\n` +
      (currentUser?.plan === 'free'
        ? '無料お試しプランは1日3回までです。Basicプランにすると1日10回まで利用できます。'
        : '')
    );
    return false;
  }
  return true;
};



// ✅ 親ユーザー情報を取得
const fetchParentData = async (parentId) => {
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', parentId)
    .single();

  if (error) {
    console.error('親データ取得エラー:', error);
  } else {
    setParentData(data);
  }
};

// ✅ 親の最新体調を取得
const fetchParentSafetyCheck = async (parentId) => {
  const { data,error } = await supabase
    .from('safety_checks')
    .select('status, created_at')
    .eq('user_id', parentId)
    .order('created_at', { ascending: false })
    .limit(1)
    .single();

  if (error) {
    console.error('親の体調取得エラー:', error);
    setParentSafetyCheck(null);
  } else {
    setParentSafetyCheck(data);
  }
};
// ---------- ✅【ここに追加】最新の体調を取得 ----------
  const fetchLatestSafetyCheck = useCallback(async () => {
    if (!currentUser) return;

    const { data, error } = await supabase
      .from('safety_checks')
      .select('status, created_at')
      .eq('user_id', currentUser.id)
      .order('created_at', { ascending: false })
      .limit(1)
      .single();

    if (error) {
      console.error('最新体調取得エラー:', error);
    } else if (data) {
      setSafetyChecks([{
        id: 'latest',
        status: data.status,
        date: new Date(data.created_at).toLocaleString('ja-JP'),
      }]);
    }
  }, [currentUser]);
// ✅ 親の今日の服薬記録を取得
const fetchParentMedications = async (parentId) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const { data, error } = await supabase
    .from('medication_logs')
    .select('*')
    .eq('user_id', parentId)
    .gte('taken_at', today.toISOString());

  if (error) {
    console.error('親の服薬データ取得エラー:', error);
    return [];
  } else {
    console.log('親の服薬データ:', data);
    return data || [];
  }
};
  const fetchUsers = useCallback(async () => {
    const { data, error } = await supabase
      .from("users")
      .select("*");

    if (error) {
      console.error("Supabase error:", error);
    } else {
      setUsers(data || []);
    }
  }, []);

  // ✅ 招待したユーザー一覧を取得
const fetchInvitedUsers = async () => {
  if (!currentUser || !currentUser.invite_code) {
    console.log('招待コードがありません');
    return;
  }

  const { data, error } = await supabase
    .from('users')
    .select('name, created_at, role')
    .eq('invited_by', currentUser.invite_code)
    .order('created_at', { ascending: false });

  if (error) {
    console.error('招待履歴取得エラー:', error);
    setInvitedUsers([]);
  } else {
    console.log('招待したユーザー:', data);
    setInvitedUsers(data || []);
  }
};
// ✅ プラン変更
const changePlan = async (newPlan) => {
  if (!currentUser) {
    alert('ユーザーが設定されていません');
    return;
  }

  const { error } = await supabase
    .from('users')
    .update({ plan: newPlan })
    .eq('id', currentUser.id);

  if (error) {
    console.error('プラン変更エラー:', error);
    alert('プラン変更に失敗しました: ' + error.message);
  } else {
    console.log('プラン変更成功:', newPlan);
    alert(`プランを${newPlan === 'free' ? '無料' : 'Basic'}プランに変更しました。ページをリロードします。`);
    
    // ✅ ページを強制リロード
    window.location.reload();
  }
};
// ✅ ログイン処理
const handleLogin = async (userId) => {
  const { data, error } = await supabase
    .from('users')
    .select('*')
    .eq('id', userId)
    .single();

  if (error) {
    console.error('ログインエラー:', error);
    alert('ログインに失敗しました');
  } else {
    console.log('ログインユーザー:', data);
    setCurrentUser(data);
    setIsLoggedIn(true);
  // ✅ ログイン状態を保存
    localStorage.setItem('currentUserId', data.id);
  }
};
// ✅ 招待コードでログイン
const handleInviteCodeLogin = async (inviteCode) => {
  if (!inviteCode || inviteCode.length !== 4) {
    alert('4桁の招待コードを入力してください');
    return;
  }

  // 招待コードでユーザーを検索
  const { data: user, error } = await supabase
    .from('users')
    .select('*')
    .eq('invite_code', inviteCode.toUpperCase())
    .eq('role', 'parent')
    .single();

  if (error || !user) {
    alert('招待コードが見つかりません');
    return;
  }

  // ログイン処理
  await handleLogin(user.id);
};
// ✅ 招待コード生成（4桁）
const generateInviteCode = () => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

// 郵便番号から住所を取得
const fetchAddressFromPostalCode = async (postalCode) => {
  try {
    const cleanedCode = postalCode.replace(/[^0-9]/g, ''); // ハイフン削除
    if (cleanedCode.length !== 7) return null;
    
    const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${cleanedCode}`);
    const data = await response.json();
    
    if (data.status === 200 && data.results && data.results.length > 0) {
      const result = data.results[0];
      return {
        prefecture: result.address1,
        city: result.address2 + result.address3
      };
    }
    return null;
  } catch (error) {
    console.error('郵便番号検索エラー:', error);
    return null;
  }
};
const handlePostalCodeChange = async (e) => {
  let value = e.target.value;
  
  // ✅ 全角数字を半角に変換
  value = value.replace(/[０-９]/g, (s) => {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
  });
  
  // ✅ 全角ハイフンを半角に変換
  value = value.replace(/ー/g, '-');
  
  setPostalCode(value);
  
  const cleanedCode = value.replace(/[^0-9]/g, '');
  if (cleanedCode.length === 7) {
    const address = await fetchAddressFromPostalCode(value);
    if (address) {
      setPrefecture(address.prefecture);
      setCity(address.city);
    }
  }
};
// ✅ メイン使用者の登録
const registerMainUser = async () => {
  if (!registrationName.trim()) {
    alert('お名前を入力してください');
    return;
  }

  // ✅ 招待コードがある場合は既存ユーザーと紐付け
  if (inviteCode.trim() && inviteCode.length === 4) {
    // 招待コードで既存ユーザー（サポート側）を検索
    const { data: existingUser, error: searchError } = await supabase
      .from('users')
      .select('*')
      .eq('invite_code', inviteCode.toUpperCase())
      .eq('role', 'child')
      .single();

    if (searchError || !existingUser) {
      alert('招待コードが見つかりません。正しいコードを入力してください。');
      return;
    }

    // メイン使用者として登録し、既存サポートユーザーと紐付け
    // ✅ 既存ユーザーの招待コードをそのまま使用（新しく発行しない）
    const { data, error } = await supabase
      .from('users')
      .insert([
        {
          name: registrationName,
          role: 'parent',
          plan: 'free',
          invite_code: inviteCode.toUpperCase(), // ← 既存の招待コードを使用
          postal_code: postalCode || null,
          prefecture: prefecture || null,
          city: city || null,
          linked_user_id: existingUser.id
        }
      ])
      .select()
      .single();

    if (error) {
      console.error('登録エラー:', error);
      alert('登録に失敗しました: ' + error.message);
      return;
    }

    // 既存サポートユーザーのlinked_user_idを更新
    await supabase
      .from('users')
      .update({ linked_user_id: data.id })
      .eq('id', existingUser.id);

    alert(`登録完了！${existingUser.name}さんと紐付けられました。\n招待コード: ${inviteCode.toUpperCase()}`);
    setCurrentUser(data);
    setIsLoggedIn(true);
    setRegistrationStep('select');
    setRegistrationName('');
    setPostalCode('');
    setPrefecture('');
    setCity('');
    setInviteCode('');
    localStorage.setItem('currentUserId', data.id);
    return;
  }

  // ✅ 招待コードがない場合は通常登録
  const code = generateInviteCode();

  const { data, error } = await supabase
    .from('users')
    .insert([
      {
        name: registrationName,
        role: 'parent',
        plan: 'free',
        invite_code: code,
        postal_code: postalCode || null,
        prefecture: prefecture || null,
        city: city || null
      }
    ])
    .select()
    .single();

  if (error) {
    console.error('登録エラー:', error);
    alert('登録に失敗しました: ' + error.message);
  } else {
    console.log('登録成功:', data);
    alert(`登録完了！招待コード: ${code}\nこのコードを見守る方に伝えてください。`);
    setCurrentUser(data);
    setIsLoggedIn(true);
    setRegistrationStep('select');
    setRegistrationName('');
    setPostalCode('');
    setPrefecture('');
    setCity('');

    // ✅ ログイン状態を保存
    localStorage.setItem('currentUserId', data.id);
  }
};

// ✅ 今日なぞなぞを使ったかチェック
const checkRiddleUsedToday = async () => {
  if (!currentUser) return true; // 使用済み扱い

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const { data, error } = await supabase
    .from('riddle_logs')
    .select('id')
    .eq('user_id', currentUser.id)
    .gte('used_at', today.toISOString());

  if (error) {
    console.error('なぞなぞチェックエラー:', error);
    return true; // エラー時は使用済み扱い
  }

  return data && data.length > 0; // データがあれば使用済み
};

// ✅ なぞなぞ使用を記録
const logRiddleUsage = async () => {
  if (!currentUser) return;

  const { error } = await supabase
    .from('riddle_logs')
    .insert([{ user_id: currentUser.id }]);

  if (error) {
    console.error('なぞなぞ記録エラー:', error);
  }
};
const startRiddle = async () => {
  // 今日使ったかチェック
  const used = await checkRiddleUsedToday();
  if (used) {
    alert('なぞなぞは1日1回です。また明日挑戦してください！');
    return;
  }

  setIsLoading(true);
  setClaudeMessage('考え中... 少々お待ちください');  // ← 追加
  setShowMessage(true);  // ← 追加


  // キャラクタープロンプトを取得
  const characterPrompt = CHARACTER_PROMPTS[selectedCharacter];
// ✅ リストからランダムに1つ選ぶ
  const randomRiddle = RIDDLE_LIST[Math.floor(Math.random() * RIDDLE_LIST.length)];

  const message = `
${characterPrompt.prompt}

【指示】
以下のなぞなぞを、あなたの口調で出してください。

なぞなぞ: 「${randomRiddle.question}」

【重要】
- 問題文の内容は変えない
- あなたの口調で自然に話す
- 答えは絶対に言わない
- 短く簡潔に

【出力例】
"さあ、なぞなぞですよ。${randomRiddle.question}"
`;

  const result = await callClaudeWithVoice(message);
  
  if (result && result.text) {
    setRiddleData({ 
      question: randomRiddle.question, 
      answer: randomRiddle.answer,
      audio: result.audio 
    });
    setShowRiddle(true);
    setCountdown(5);
    setShowAnswer(false);
    
    // 使用記録
    await logRiddleUsage();
    
    // 音声再生が終わってからカウントダウン開始
    await speak(result.text, result.audio, false);
    
  }
  
  setIsLoading(false);
  // ✅ 利用回数を更新
  await fetchRemainingUses();
};

// ✅ カウントダウン処理
const startCountdown = () => {
  let count = 5;
  const timer = setInterval(() => {
    count--;
    setCountdown(count);
    
    if (count === 0) {
      clearInterval(timer);
      revealAnswer();
    }
  }, 1000);
};

// ✅ 答えを表示
const revealAnswer = async () => {
  const characterPrompt = CHARACTER_PROMPTS[selectedCharacter];
  
  const message = `
${characterPrompt.prompt}

このなぞなぞの答えを発表してください。

なぞなぞ: 「${riddleData?.question}」
答え: 「${riddleData?.answer}」

【ルール】
- 「正解は〇〇です！」という形式で
- 一言だけ（20文字以内）
- あなたの口調で

【出力例】
"正解は${riddleData?.answer}です！"
`;

  const result = await callClaudeWithVoice(message);
  
  if (result) {
    // ✅ 余計な文字を削除
let cleanAnswer = result.text;
cleanAnswer = cleanAnswer.replace(/\/\/.*$/gm, ''); // "//" 以降を削除
cleanAnswer = cleanAnswer.replace(/←.*$/gm, '');    // "←" 以降を削除
cleanAnswer = cleanAnswer.trim();                   // 前後の空白削除
    // ✅ 答えを取得してから表示を切り替え
    setRiddleData({ ...riddleData, answerText: cleanAnswer });
    setShowAnswer(true);  // ← ここに移動
    await speak(result.text, result.audio, false);
  }
};

// ✅ マイク音量を監視
const startMicMonitoring = useCallback(() => {
  if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
    console.log('マイク監視: 非対応');
    return;
  }

  navigator.mediaDevices.getUserMedia({ audio: true })
    .then(stream => {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const analyser = audioContext.createAnalyser();
      const microphone = audioContext.createMediaStreamSource(stream);
      const dataArray = new Uint8Array(analyser.frequencyBinCount);

      microphone.connect(analyser);
      analyser.fftSize = 256;

      const checkLevel = () => {
        analyser.getByteFrequencyData(dataArray);
        const average = dataArray.reduce((a, b) => a + b) / dataArray.length;
        setMicLevel(Math.min(100, average * 2)); // 0-100の範囲に正規化

        if (isListening) {
          requestAnimationFrame(checkLevel);
        }
      };

      checkLevel();
    })
    .catch(err => {
      console.error('マイクアクセスエラー:', err);
    });
}, [isListening]);

// ✅ 連絡先を取得
const fetchEmergencyContacts = async () => {
  if (!currentUser) return;

  const { data, error } = await supabase
    .from('emergency_contacts')
    .select('*')
    .eq('user_id', currentUser.id)
    .order('created_at', { ascending: true });

  if (error) {
    console.error('連絡先取得エラー:', error);
    setEmergencyContacts([]);
  } else {
    setEmergencyContacts(data || []);
  }
};

// ✅ 連絡先を保存
const saveEmergencyContacts = async () => {
  if (!currentUser) return;

  // 既存の連絡先を全削除
  await supabase
    .from('emergency_contacts')
    .delete()
    .eq('user_id', currentUser.id);

  // 新しい連絡先を保存
  const contactsToSave = emergencyContacts.filter(c => c.name && c.phone);
  
  if (contactsToSave.length > 0) {
    const { error } = await supabase
      .from('emergency_contacts')
      .insert(
        contactsToSave.map(c => ({
          user_id: currentUser.id,
          name: c.name,
          relation: c.relation || null,
          phone: c.phone
        }))
      );

    if (error) {
      console.error('連絡先保存エラー:', error);
      alert('保存に失敗しました');
    } else {
      alert('連絡先を保存しました');
      fetchEmergencyContacts(); // 再取得
    }
  }
};

// ✅ サポーターの登録
const registerSupportUser = async () => {
  if (!registrationName.trim()) {
    alert('お名前を入力してください');
    return;
  }

  // ✅ 招待コードがある場合は既存ユーザー（メイン使用者）と紐付け
  if (inviteCode.trim() && inviteCode.length === 4) {
    // 招待コードで親を検索
    const { data: parentUser, error: searchError } = await supabase
      .from('users')
      .select('*')
      .eq('invite_code', inviteCode.toUpperCase())
      .eq('role', 'parent')
      .single();

    if (searchError || !parentUser) {
      alert('招待コードが見つかりません。正しいコードを入力してください。');
      return;
    }

    // ✅ 既存メイン使用者の招待コードをそのまま使用（新しく発行しない）
    const { data, error } = await supabase
      .from('users')
      .insert([
        {
          name: registrationName,
          role: 'child',
          plan: 'basic',
          linked_user_id: parentUser.id,
          invited_by: parentUser.invite_code,
          invite_code: inviteCode.toUpperCase() // ← 既存の招待コードを共有
        }
      ])
      .select()
      .single();

    if (error) {
      console.error('登録エラー:', error);
      alert('登録に失敗しました: ' + error.message);
      return;
    }

    console.log('登録成功:', data);
    alert(`登録完了！${parentUser.name}さんを見守ります。`);
    setCurrentUser(data);
    setIsLoggedIn(true);
    setRegistrationStep('select');
    setRegistrationName('');
    setInviteCode('');
    localStorage.setItem('currentUserId', data.id);
    return;
  }

  // ✅ 招待コードがない場合は独立したサポートユーザーとして登録
  const code = generateInviteCode();

  const { data, error } = await supabase
    .from('users')
    .insert([
      {
        name: registrationName,
        role: 'child',
        plan: 'basic',
        invite_code: code
      }
    ])
    .select()
    .single();

  if (error) {
    console.error('登録エラー:', error);
    alert('登録に失敗しました: ' + error.message);
  } else {
    console.log('登録成功:', data);
    alert(`登録完了！招待コード: ${code}\nこのコードをメイン使用者の方に伝えてください。`);
    setCurrentUser(data);
    setIsLoggedIn(true);
    setRegistrationStep('select');
    setRegistrationName('');
    setInviteCode('');

    // ✅ ログイン状態を保存
    localStorage.setItem('currentUserId', data.id);
  }
};
// ✅ ログアウト処理
const handleLogout = () => {
  setCurrentUser(null);
  setIsLoggedIn(false);
  setActiveTab('home');
  setSafetyCheckHistory([]);
  setMedicationHistory([]);
  setParentData(null);
  setParentSafetyCheck(null);
  setParentMedications([]);

  
};
const getParentSummary = () => {
  // ✅ DBから取得した親の体調と服薬を表示
  const totalMeds = 3; // 1日の服薬回数（朝・昼・夜）
  const takenMeds = parentMedications.length;
  
  return {
    condition: parentSafetyCheck ? parentSafetyCheck.status : '未記録',
    medication: `${takenMeds} / ${totalMeds} 回`
  };
};
// ✅ 体調を Supabase に保存
const saveSafetyCheckToDB = async (status) => {
  if (!currentUser) {
    console.error('ユーザーが設定されていません');
    return;
  }

 const { error } = await supabase
    .from('safety_checks')
    .insert([
      {
        user_id: currentUser.id,
        status: status
      }
    ]);

  if (error) {
    console.error('保存エラー:', error);
    alert('体調の保存に失敗しました: ' + error.message);
  } else {
    console.log('体調を保存しました:', status);
  }
};

 // ✅ 服薬記録を Supabase に保存
const saveMedicationToDB = async (medicationName) => {
  if (!currentUser) {
    console.error('ユーザーが設定されていません');
    return;
  }

 const { error } = await supabase
    .from('medication_logs')
    .insert([
      {
        user_id: currentUser.id,
        name: medicationName,
        taken_at: new Date().toISOString()
      }
    ]);

  if (error) {
    console.error('服薬記録の保存エラー:', error);
    alert('服薬記録の保存に失敗しました: ' + error.message);
  } else {
    console.log('服薬記録を保存しました:', medicationName);
  }
}; 

// ✅ 過去7日分の体調を取得
const fetchSafetyCheckHistory = async (userId) => {
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

  const { data, error } = await supabase
    .from('safety_checks')
    .select('status, created_at')
    .eq('user_id', userId)
    .gte('created_at', sevenDaysAgo.toISOString())
    .order('created_at', { ascending: false });

  if (error) {
    console.error('履歴取得エラー:', error);
    return [];
  } else {
    console.log('取得した履歴:', data);
    return data || [];
  }
};

// ✅ 過去7日分の服薬を取得
const fetchMedicationHistory = async (userId) => {
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

  const { data, error } = await supabase
    .from('medication_logs')
    .select('name, taken_at')
    .eq('user_id', userId)
    .gte('taken_at', sevenDaysAgo.toISOString())
    .order('taken_at', { ascending: false });

  if (error) {
    console.error('服薬履歴取得エラー:', error);
    return [];
  } else {
    console.log('取得した服薬履歴:', data);
    return data || [];
  }
};

  // 連続対話フラグ
  const [continueConversation, setContinueConversation] = useState(false); 

  // 音声認識インスタンスを useRef で保持 (無限ループ対策)
  const recognitionRef = useRef(null); 

  // --- 外部API関数（メモ化） ---

  // 天気情報取得
  const getWeather = useCallback(async () => {
    try {
     const response = await fetch('/api/weather');
      if (!response.ok) {
        throw new Error('天気情報の取得に失敗しました');
      }
      const data = await response.json();
      // デバッグ用にSaseboの天気情報を確認
      return data;
    } catch (error) {
      console.error('Weather Error:', error);
      return null;
    }
  }, []);

  // Claude API呼び出し
 // ✅ Claude + 音声生成（プラン別）
  const callClaudeWithVoice = useCallback(async (message) => {
  try {
    console.log('=== callClaudeWithVoice開始 ===');
    console.log('プラン:', currentUser?.plan);
    
    setIsLoading(true);
    
    const userPlan = currentUser?.plan || 'free';
    console.log('使用するプラン:', userPlan);
    
    if (userPlan === 'free') {
      console.log('無料プラン: chat API呼び出し');
      // 無料プラン: 既存のchat関数（テキストのみ）
      const response = await fetch('/api/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message })
      });
      
      console.log('レスポンスステータス:', response.status);
      
      if (!response.ok) throw new Error('API呼び出しに失敗しました');
      
      const data = await response.json();
      console.log('取得したデータ:', data);
      
      const result = { text: data.response, audio: null };
      console.log('返却する結果:', result);
      
      return result;
      
    } else {
      console.log('Basicプラン: paid-tts API呼び出し');
      // 有料Basicプラン: paid-tts関数（テキスト + OpenAI音声）
      const response = await fetch('/api/paid-tts', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          message,
          character: selectedCharacter 
        })
      });
      
      console.log('レスポンスステータス:', response.status);
      
      if (!response.ok) throw new Error('API呼び出しに失敗しました');
      
      const data = await response.json();
      console.log('取得したデータ:', data);
      
      const result = { text: data.text, audio: data.audio };
      console.log('返却する結果:', result);
      
      return result;
    }
    
  } catch (error) {
    console.error('=== API Error ===', error);
    alert('エラーが発生しました。もう一度お試しください。');
    return null;
  } finally {
    setIsLoading(false);
    console.log('=== callClaudeWithVoice終了 ===');
  }
}, [currentUser, selectedCharacter]);

  // --- 音声関連の関数（メモ化） ---


// ✅ 音声再生（プラン別）
// --- 音声関連の関数（メモ化） ---

const speak = useCallback(async (text, audioBase64 = null, isContinuous = false) => {
  const userPlan = currentUser?.plan || 'free';

  // 前の音声を完全停止
  if (currentAudio) {
    try {
      currentAudio.pause();
      currentAudio.src = "";
      currentAudio.load();
    } catch (e) {}
    setCurrentAudio(null);
  }
  

 if (audioBase64) {
    // 有料Basic: OpenAI TTS音声を再生
    try {
      const audio = new Audio(`data:audio/mp3;base64,${audioBase64}`);
      audio.volume = 1.0;
      setCurrentAudio(audio);
      
      // ✅ 音声が終わるまで待つ Promise を追加
      await new Promise((resolve) => {
        audio.onended = () => {
          setCurrentAudio(null);
          setContinueConversation(isContinuous);
          resolve();
        };
        audio.play().catch((error) => {
          console.error('音声再生エラー:', error);
          setCurrentAudio(null);
          resolve();
        });
      });
    } catch (error) {
      console.error('音声再生エラー:', error);
      setCurrentAudio(null);
    }

    
  } else {
    // 無料: ブラウザ音声
    if (!('speechSynthesis' in window)) return;

    window.speechSynthesis.cancel();

    const character = CHARACTER_PROMPTS[selectedCharacter];
    const voiceType = character.voiceType;

    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'ja-JP';
    utterance.volume = 1.0;

    switch (voiceType) {
      case 'child-high':
        utterance.rate = 1.15;
        utterance.pitch = 1.8;
        break;
      case 'female-soft':
        utterance.rate = 1.05;
        utterance.pitch = 1.4;
        break;
      case 'female-loud':
        utterance.rate = 1.1;
        utterance.pitch = 1.2;
        break;
      case 'male-energetic':
        utterance.rate = 1.15;
        utterance.pitch = 0.9;
        break;
      case 'male-calm':
        utterance.rate = 1.0;
        utterance.pitch = 0.8;
        break;
      
default:
        utterance.rate = 1.05;
        utterance.pitch = 1.4;
    }

    utterance.onend = () => {
  setContinueConversation(isContinuous);
};
// ✅ より自然な音声を選択
const voices = window.speechSynthesis.getVoices();
const jaVoices = voices.filter(v => v.lang === 'ja-JP');

// 優先順位: Nanami > Ayumi > Sayaka > Haruka > その他
const preferredVoice = jaVoices.find(v => 
  v.name.includes('Nanami')
) || jaVoices.find(v => 
  v.name.includes('Ayumi')
) || jaVoices.find(v => 
  v.name.includes('Sayaka')
) || jaVoices.find(v => 
  v.name.includes('Haruka')
);

if (preferredVoice) {
  utterance.voice = preferredVoice;
  console.log('選択された音声:', preferredVoice.name);
} else if (jaVoices.length > 0) {
  utterance.voice = jaVoices[0];
  console.log('デフォルト音声:', jaVoices[0].name);
}
window.speechSynthesis.speak(utterance);
  }
}, [selectedCharacter, currentUser, currentAudio]);
 
  
  // 音声認識開始
  // eslint-disable-next-line react-hooks/exhaustive-deps
 const startListening = useCallback((isSilentRestart = false) => {
  // ✅ 前の会話を停止（サイレント再起動時は除く）
  if (!isSilentRestart) {
    stopConversation();
  }
  const recognition = recognitionRef.current;
  if (recognition && !isListening) {
    setIsListening(true);

    // ✅ マイク監視を開始
    startMicMonitoring();

    // 認識をスタート
    setTimeout(() => {
      try {
        // ✅ 準備中メッセージを表示
        setClaudeMessage('準備中...少々お待ちください');
        setShowMessage(true);
        
        recognition.start();
        
        // ✅ 2秒後に「お話しください」に変更
        setTimeout(() => {
          setClaudeMessage('お話しください（はっきりとゆっくり）\n\n※一部端末では音声が認識されない場合があります');
        }, 2000);
        
      } catch (error) {
        console.error('音声認識開始エラー:', error);
        setIsListening(false);
        setShowMessage(false);
        
        // エラー時は再度試みる
        if (error.message.includes('already started')) {
          recognition.stop();
          setTimeout(() => {
            try {
              // ✅ 準備中メッセージを表示
              setClaudeMessage('準備中...少々お待ちください');
              setShowMessage(true);
              
              recognition.start();
              
              // ✅ 2秒後に「お話しください」に変更
              setTimeout(() => {
                setClaudeMessage('お話しください（はっきりとゆっくり）');
              }, 2000);
            } catch (e) {
              console.error('再起動失敗:', e);
            }
          }, 500);
        }
      }
    }, isSilentRestart ? 0 : 2000); 
  } else if (!recognition) {
    speak('申し訳ありません。お使いのブラウザは音声認識に対応していません', false);
  }
}, [isListening, speak, stopConversation, startMicMonitoring]);

  // 音声入力処理
 const handleVoiceInput = useCallback(async (transcript) => {
  
  // ✅ 「考え中...」に変更
  setClaudeMessage('考え中... 少々お待ちください');
  setShowMessage(true);
  
  const weather = await getWeather();
  
  const message = `ユーザーからの質問:「${transcript}」

今日の佐世保市の天気情報:
- 天気:${weather ? weather.description : '情報なし'}
- 気温:${weather ? weather.temp + '度' : '情報なし'}

この質問に対して、180文字以内で自然な会話文で答えてください。

※重要:音声で読み上げられるので、以下に注意してください:
- 「一日」は「いちにち」と平仮名で書く
- 「今日」は「きょう」と平仮名で書く
- 読み間違えやすい漢字は平仮名にする
- 番号や記号は使わない

優しく寄り添う会話調でお願いします。`;
  
  const result = await callClaudeWithVoice(message);
  if (result) {
    setClaudeMessage(result.text);
    setShowMessage(true);
    await speak(result.text, result.audio, false);  // ✅ 連続会話を無効化
  }
  
  // ✅ 最後に必ず isListening を false にする
  setIsListening(false);

  // ✅ 利用回数を更新（直接実行）
  if (currentUser) {
    const count = await getTodayUsageCount();
    let limit;
if (currentUser?.plan === 'free') {
  limit = 3;
} else if (currentUser?.plan === 'basic') {
  limit = 7;
} else if (currentUser?.plan === 'value') {
  limit = 15;
} else {
  limit = 3;
}
    const remaining = Math.max(0, limit - count);
    setRemainingUses(`${remaining}/${limit}`);
  }
  
}, [getWeather, callClaudeWithVoice, speak, currentUser, getTodayUsageCount]);

  // --- 初期化とロジック ---
// ✅ ページ読み込み時に自動ログイン
useEffect(() => {
  const savedUserId = localStorage.getItem('currentUserId');
  
  if (savedUserId && !currentUser) {
    console.log('保存されたユーザーIDでログイン:', savedUserId);
    handleLogin(savedUserId);
  }
}, []);

  // 時計の更新
  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // 音声認識の初期化とイベントハンドラの設定 (無限ループ対策)
  useEffect(() => {
    if (!('webkitSpeechRecognition' in window || 'SpeechRecognition' in window)) {
      return;
    }
const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
if (!recognitionRef.current) {
  const recognitionInstance = new SpeechRecognition();
  recognitionInstance.lang = 'ja-JP';
  recognitionInstance.continuous = true;  // ✅ true に変更
  recognitionInstance.interimResults = false;  // ✅ false になっているか確認
  recognitionInstance.maxAlternatives = 1;
  // ✅ 聞き取り時間を延長（Android のみ有効）
  if (recognitionInstance.speechTimeout !== undefined) {
    recognitionInstance.speechTimeout = 10000;  // 10秒
  }
  recognitionRef.current = recognitionInstance;
}
    const recognition = recognitionRef.current;
    
    // イベントハンドラを毎回設定し直す (useCallbackで定義された関数が最新の状態を参照するため)
  recognition.onresult = async (event) => {
  // ✅ 既に処理中なら無視
  if (!isListening) {
    console.log('既に処理中のため無視');
    return;
  }
  
  const transcript = event.results[0][0].transcript;
  console.log('認識された言葉:', transcript);
  
  // ✅ 短すぎる認識を無視
  if (transcript.trim().length < 2) {
    console.log('認識が短すぎるため無視:', transcript);
    setIsListening(false);
    return;
  }
  
  // ✅ 音声認識を即座に停止
  try {
    recognition.stop();
  } catch (e) {
    console.log('停止エラー:', e);
  }
  
  setIsListening(false);
  setContinueConversation(false);
  await handleVoiceInput(transcript);
};
    
    recognition.onerror = (event) => {
      console.error('音声認識エラー:', event.error);
      // ✅ 必ず isListening を false にする
      setIsListening(false);
      setContinueConversation(false); 
      setShowMessage(false);  // ✅ エラー時はメッセージを消す
      if (event.error !== 'no-speech' && event.error !== 'aborted') {
        speak('すみません、聞き取れませんでした。もう一度お願いします。', true); // エラー後も対話継続
      }
    };
    // ✅ ここに追加
recognition.onstart = () => {
  console.log('音声認識開始');
  // ✅ 10秒後に自動停止
  setTimeout(() => {
    if (recognitionRef.current && isListening) {
      try {
        console.log('10秒経過: 音声認識を停止');
        recognitionRef.current.stop();
      } catch (e) {
        console.log('停止エラー:', e);
      }
    }
  }, 10000);  // 10秒
};
    recognition.onend = () => {
      console.log('=== 音声認識終了 ===');
      // ✅ 必ず isListening を false にする
      setIsListening(false);
      // 読み上げ終了(speakのonend)によってセットされた continueConversation が true なら、認識を再開
      if (continueConversation) {
          console.log('--- 連続対話モード: 認識を再開 ---');
          startListening(true);
      } else {
          // 何も話さなかった場合や、手動で終了した場合は完全に停止
          console.log('--- 対話終了 ---');
      }
    };
    
    // Voiceのロードを待つ
    if ('speechSynthesis' in window) {
      window.speechSynthesis.getVoices();
    }

    // クリーンアップ関数
    return () => {
      // recognition.abort() を実行しないことで、途中で終わった会話を中断させずに済む
    };

  }, [handleVoiceInput, speak, continueConversation, startListening]); 
  
  // ✅ 初回データ取得
  // ✅ 初回データ取得
  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  // ✅ ユーザーログイン後のデータ取得
 useEffect(() => {
    if (currentUser) {
      console.log('currentUserがセットされました:', currentUser);
      console.log('role:', currentUser.role);
      console.log('linked_user_id:', currentUser.linked_user_id);
      
      // ✅ ここに追加（fetchLatestSafetyCheck の前）
      const hasSeenGuide = localStorage.getItem('hasSeenHomeAddGuide');
      if (!hasSeenGuide) {
        setShowHomeAddGuide(true);
        localStorage.setItem('hasSeenHomeAddGuide', 'true');
      }

      fetchLatestSafetyCheck();
      fetchEmergencyContacts();
      
      if (currentUser.role === 'child' && currentUser.linked_user_id) {
        console.log('親データを取得します。linked_user_id:', currentUser.linked_user_id);
        fetchParentData(currentUser.linked_user_id);
        fetchParentSafetyCheck(currentUser.linked_user_id);
        
        // ✅ 親の服薬データも取得
        fetchParentMedications(currentUser.linked_user_id).then(meds => {
          setParentMedications(meds);
        });
        
        // ✅ 子の場合は親の履歴を取得
        fetchSafetyCheckHistory(currentUser.linked_user_id).then(history => {
          setSafetyCheckHistory(history);
        });
        fetchMedicationHistory(currentUser.linked_user_id).then(history => {
          setMedicationHistory(history);
        });
     
      }
    }
  }, [currentUser, fetchLatestSafetyCheck]);
  
  // 挨拶メッセージ
  const getGreeting = () => {
    const hour = currentTime.getHours();
    if (hour < 10) return 'おはようございます';
    if (hour < 18) return 'こんにちは';
    return 'こんばんは';
  };
  
  // 今日のサマリー
  const getTodaysSummary = () => {
    const today = new Date().toLocaleDateString('ja-JP');
    const todayChecks = safetyChecks.filter(c => c.date.includes(today));
    const takenMeds = medications.filter(m => m.taken).length;
    return {
      safetyCheck: todayChecks.length > 0 ?
        todayChecks[0].status : '未記録',
      medications: `${takenMeds}/${medications.length}回`,
      lastCheck: todayChecks.length > 0 ?
        todayChecks[0].date : 'なし'
    };
  };
const summary = getTodaysSummary();
// ✅ 残り利用回数を取得
const [remainingUses, setRemainingUses] = useState(null);

const fetchRemainingUses = useCallback(async () => {
  if (!currentUser) return;
  
  const count = await getTodayUsageCount();
  let limit;
if (currentUser?.plan === 'free') {
  limit = 3;
} else if (currentUser?.plan === 'basic') {
  limit = 7;
} else if (currentUser?.plan === 'value') {
  limit = 15;
} else {
  limit = 3;
}
  const remaining = Math.max(0, limit - count);  // ✅ マイナスを0に修正
  
  setRemainingUses(`${remaining}/${limit}`);
}, [currentUser]);
// ✅ サブスクリプション情報を取得
const [subscriptionInfo, setSubscriptionInfo] = useState(null);
const fetchSubscriptionInfo = useCallback(async () => {
  console.log('=== fetchSubscriptionInfo 開始 ===');
  
  if (!currentUser) {
    setSubscriptionInfo(null);
    return;
  }

  // ✅ 子の場合は親のIDを使う
  const targetUserId = currentUser.role === 'child' && currentUser.linked_user_id 
    ? currentUser.linked_user_id 
    : currentUser.id;

  try {
    // Supabase から解約予定日を取得
    const { data, error } = await supabase
      .from('users')
      .select('subscription_cancel_at, stripe_subscription_id, plan')
      .eq('id', targetUserId)
      .single();

    console.log('Supabase データ:', data);

    if (error) {
      console.error('サブスクリプション情報取得エラー:', error);
      return;
    }

    if (data.stripe_subscription_id) {
      console.log('Stripe API を呼び出し...');
      
      const response = await fetch('/api/get-subscription-info', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          subscriptionId: data.stripe_subscription_id 
        })
      });

      const subData = await response.json();
      console.log('Stripe データ:', subData);
      if (subData.current_period_end) {
  const info = {
    nextBillingDate: new Date(subData.current_period_end * 1000),
    cancelAt: subData.cancel_at_period_end ? new Date(subData.current_period_end * 1000) : null,
    willCancel: subData.cancel_at_period_end === true,
    currentPlan: data.plan
  };
  
  console.log('✅ サブスクリプション情報をセット:', info);
  setSubscriptionInfo(info);
}
    } else {
      console.log('stripe_subscription_id がありません');
      setSubscriptionInfo(null);
    }
  } catch (error) {
    console.error('サブスクリプション情報取得エラー:', error);
  }
}, [currentUser]);
// ✅ ログイン時・プラン変更時に取得
useEffect(() => {
  if (currentUser) {
    fetchSubscriptionInfo();
  }
}, [currentUser, fetchSubscriptionInfo]);
// ✅ ログイン時・ページ表示時に取得
useEffect(() => {
  if (currentUser) {
    fetchRemainingUses();
  }
}, [currentUser, fetchRemainingUses]);

  // 文字入力の処理
  const handleTextInput = async () => {
  if (!textInput.trim()) return;
  
  const userQuestion = textInput;
  setTextInput('');
  setShowTextInput(false);
  
  setIsLoading(true);  // ← 追加（ローディング表示）
  setClaudeMessage('考え中... 少々お待ちください');  // ← 追加
  setShowMessage(true);  // ← 追加（メッセージ表示）
  
  const weather = await getWeather();
    const message = `ユーザーからの質問:「${userQuestion}」
今日の佐世保市の天気情報:
- 天気:${weather ? weather.description : '情報なし'}
- 気温:${weather ? weather.temp + '度' : '情報なし'}

この質問に対して、200文字以内で自然な会話文で答えてください。
※重要:音声で読み上げられるので、以下に注意してください:
- 「一日」は「いちにち」と平仮名で書く
- 「今日」は「きょう」と平仮名で書く
- 読み間違えやすい漢字は平仮名にする
- 番号や記号は使わない

優しく寄り添う会話調でお願いします。`;
   
  const result = await callClaudeWithVoice(message);
    
    if (result) {
      setClaudeMessage(result.text);
      setShowMessage(true);
      await speak(result.text, result.audio, true);
    }
    // ✅ 利用回数を更新
  await fetchRemainingUses();
  };
 
  // 体調チェック追加
  const addSafetyCheck = async (status) => {
    
  console.log('=== addSafetyCheck開始 ===', status);
  
  stopConversation();
  console.log('✓ stopConversation完了');
  
  // ✅ 利用回数チェック
  const canUse = await checkUsageLimit();
  console.log('✓ checkUsageLimit完了:', canUse);
  if (!canUse) return;

  // ✅ 利用記録
  await logUsage();
  console.log('✓ logUsage完了');

  setIsLoading(true);  // ← 追加
  setClaudeMessage('考え中... 少々お待ちください');  // ← 追加
  setShowMessage(true);  // ← 追加


  // ✅ まずDBに保存
  await saveSafetyCheckToDB(status);
  console.log('✓ saveSafetyCheckToDB完了');
  
  // ✅ 保存後に最新データを取得して画面に反映
  await fetchLatestSafetyCheck();
  console.log('✓ fetchLatestSafetyCheck完了');
  
  const check = {
    id: Date.now(),
    date: new Date().toLocaleString('ja-JP'),
    status: status,
    note: ''
  };
  setSafetyChecks([check, ...safetyChecks]);
  console.log('✓ setSafetyChecks完了');
  
  const weather = await getWeather();
  console.log('✓ getWeather完了:', weather);
  
  const greeting = getGreeting();
  console.log('✓ getGreeting完了:', greeting);
  
  // ✅ キャラクタープロンプトを取得
  const characterPrompt = CHARACTER_PROMPTS[selectedCharacter];
  console.log('✓ characterPrompt取得完了');
  
  // ✅ キャラクターを考慮したメッセージ
  const claudeMessage = `
${characterPrompt.prompt}

【状況】
- 今日の体調: ${status}
- 天気: ${weather ? weather.description : '情報なし'}
- 気温: ${weather ? weather.temp + '度' : '情報なし'}

【指示】
以下の順番で、短い文に分けて話してください：

1. 相づち（短く）
例: "……そうなんですね。"

2. 共感（ゆっくり）
例: "体調が${status}なんですね。"

3. 励まし・安心（優しく）
例: "無理しなくていいですよ。"

4. 天気の話（自然に）
例: "今日は${weather ? weather.description : ''}ですね。"

【重要ルール】
- 各文は15〜30文字以内
- 合計で100文字以内
- 口語で、やさしく

例:
"……そうなんですね。体調が良好なんですね。素晴らしいですよ。"
`;
  
  console.log('=== callClaudeWithVoice呼び出し直前 ===');
  console.log('claudeMessage長さ:', claudeMessage.length);
  
  const result = await callClaudeWithVoice(claudeMessage);
  console.log('=== callClaudeWithVoice結果 ===', result);
  
  if (result) {
    console.log('✓ result取得成功');
    setClaudeMessage(result.text);
    setShowMessage(true);
    
    console.log('=== speak呼び出し ===');
    await speak(result.text, result.audio, true);
    console.log('✓ speak完了');
  } else {
    console.log('❌ resultがnull');
    // ✅ 最後に利用回数を更新
  await fetchRemainingUses();
  }
};
  
  // 服薬記録

 const toggleMedication = async (id) => {
    // ✅ 前の会話を停止
  stopConversation();
    const med = medications.find(m => m.id === id);
    if (!med || med.taken) return;
    
    // ✅ 利用回数チェック
    const canUse = await checkUsageLimit();
    if (!canUse) return;

    setIsLoading(true);
  setClaudeMessage('考え中... 少々お待ちください');
  setShowMessage(true);


    // ✅ まずDBに保存
    await saveMedicationToDB(med.name);
    
    // ✅ 利用記録
    await logUsage();
    
    setMedications(medications.map(m => 
      m.id === id ? { ...m, taken: true } : m
    ));
   
    

    
    const weather = await getWeather();
    
    // ✅ キャラクタープロンプトを取得
const characterPrompt = CHARACTER_PROMPTS[selectedCharacter];

const message = `
${characterPrompt.prompt}

【状況】
- ${med.name}を飲みました
- 天気: ${weather ? weather.description : '情報なし'}

【指示】
以下の順番で、短い文に分けて話してください：

1. 相づち（短く）
例: "……お薬、飲んだんですね。"

2. 褒める（温かく）
例: "えらいですよ。" "よく頑張りましたね。"

3. 励まし（優しく）
例: "その調子ですよ。" "続けていきましょうね。"

【重要ルール】
- 各文は15〜30文字以内
- 合計で80文字以内
- 口語で、やさしく

例:
"……お薬、飲んだんですね。えらいですよ。その調子で、続けていきましょうね。"
`;
     const result = await callClaudeWithVoice(message);
    
    if (result) {
      setClaudeMessage(result.text);
      setShowMessage(true);
      await speak(result.text, result.audio, true);
    }
    // ✅ 最後に利用回数を更新
  await fetchRemainingUses();
  };
  const openClaudeChat = async () => {
  console.log('=== 今日の情報ボタン押下 ===');
  
  const canUse = await checkUsageLimit();
  if (!canUse) return;

  await logUsage();
  
  setIsLoading(true);
  setClaudeMessage('考え中... 少々お待ちください');
  setShowMessage(true);
  
  const greeting = getGreeting();
  const today = new Date();
  const month = today.getMonth() + 1;
  const day = today.getDate();

  // ✅ キャラクタープロンプトを取得
  const characterPrompt = CHARACTER_PROMPTS[selectedCharacter];
  
  // ✅ 郵便番号登録があるかチェック
  const userCity = currentUser?.city || null;

 const message = `
${characterPrompt.prompt}

【重要な指示】
- 「検索」という言葉は使わず、「調べる」を使う
- 例: "検索させてもらいますね" → "調べさせてもらいますね"

【必須タスク】
1. web_searchツールを使って「${month}月${day}日 何の日」を検索
2. 検索結果から1つだけ紹介
${userCity ? `3. web_searchツールを使って「${userCity} イベント 本日 ${month}月${day}日」を検索` : ''}
${userCity ? `4. 【重要】本日${month}月${day}日に開催されるイベントのみ紹介。過去や未来のイベントは絶対に含めない` : ''}

【指示】
以下の内容を、短い文で話してください：

1. 挨拶と日付
例: "${greeting}。今日は${month}月${day}日ですね。"

2. 何の日か（web_search結果）
例: "今日は〇〇の日ですよ。"

${userCity ? `3. 本日のイベント情報（web_search結果）
- 本日${month}月${day}日に開催されるイベントがあれば1つ紹介
- 本日のイベントがなければ「今日は特にイベントはないようですね」
- 【禁止】過去のイベント・毎年開催・例年開催などの情報は言わない` : ''}

4. 締めの言葉
例: "良い一日をお過ごしください。"

【重要ルール】
- 「検索」という言葉は絶対に使わない
- web_searchツールを使うことは言わない
- 合計で100文字以内
- 口語で、やさしく
- 本日${month}月${day}日のイベントがない場合は「今日は特にイベントはないようです」とだけ言う
`;

  console.log('Claude API呼び出し中...');
  
  const result = await callClaudeWithVoice(message);
  setIsLoading(false);
  
  if (result) {
    setClaudeMessage(result.text);
    setShowMessage(true);
    await speak(result.text, result.audio, false);
  }
  // ✅ 最後に利用回数を更新
  await fetchRemainingUses();
  return result;
};
  
  // ✅ ログイン・登録画面
  if (!isLoggedIn) {
    return (
      <div className="app">
        <div className="container">
          <div className="header">
            <div className="header-content">
              <div className="header-left">
               
                <div>
                 
                 
   <h1 style={{ whiteSpace: 'nowrap' }}>見守り<br />AIアプリ</h1>
                  <p className="date">ようこそ</p>
                </div>
               {/* ✅ SOERU ロゴ追加 */}
              <img 
                src={process.env.PUBLIC_URL + "/logo.png"} 
                alt="SOERU ロゴ"
                className="soeru-logo"
              />
              </div>
            </div>
          </div>

          <div className="content" style={{ paddingTop: '40px' }}>
            {/* 最初の選択画面 */}
            {registrationStep === 'select' && (
              <>
               {/* ✅ ヒーロー画像 */}
               <img 
                 src={process.env.PUBLIC_URL + "/hero.png"} 
                 alt="親が、ちょっと楽しみにしてくれるアプリ"
                 style={{ 
                   width: '100%',
                   maxWidth: '600px',
                   margin: '0 auto 24px auto',
                   display: 'block',
                   borderRadius: '0'
                 }}
               />
               
               {/* ✅ 無料お試しキャンペーン - 新デザイン */}
               <div style={{
                 textAlign: 'center',
                 margin: '0 auto 40px auto',
                 maxWidth: '600px',
                 padding: '32px 20px',
                 background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
                 borderRadius: '20px'
               }}>
                 {/* 上部：今だけ！無料で始められます */}
                 <div style={{
                   display: 'inline-block',
                   background: 'linear-gradient(135deg, #fb923c, #f97316)',
                   color: 'white',
                   fontSize: '16px',
                   fontWeight: 'bold',
                   padding: '12px 24px',
                   borderRadius: '30px',
                   marginBottom: '24px',
                   boxShadow: '0 4px 12px rgba(251, 146, 60, 0.4)',
                   whiteSpace: 'nowrap'
                 }}>
                   🎉 今だけ！無料で始められます
                 </div>

                 {/* 中央：キャッチコピー */}
                 <div style={{
                   fontSize: '24px',
                   fontWeight: 'bold',
                   color: '#78350f',
                   marginBottom: '28px',
                   lineHeight: '1.6'
                 }}>
                   毎日の<br />
                   「ちょっと話したい」が<br />
                   親の楽しみに変わる ✨
                 </div>

                 {/* 下部：CTAボタン */}
                 <button
                   onClick={() => setRegistrationStep('role-select')}
                   style={{
                     background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                     border: '4px solid #fbbf24',
                     borderRadius: '16px',
                     padding: '20px 48px',
                     fontSize: '22px',
                     fontWeight: 'bold',
                     color: 'white',
                     cursor: 'pointer',
                     boxShadow: '0 12px 32px rgba(251, 191, 36, 0.6), 0 0 20px rgba(251, 191, 36, 0.3)',
                     width: '100%',
                     maxWidth: '400px',
                     textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                     transition: 'all 0.3s ease'
                   }}
                   onMouseOver={(e) => {
                     e.currentTarget.style.transform = 'translateY(-4px)';
                     e.currentTarget.style.boxShadow = '0 14px 36px rgba(251, 191, 36, 0.7), 0 0 24px rgba(251, 191, 36, 0.4)';
                   }}
                   onMouseOut={(e) => {
                     e.currentTarget.style.transform = 'translateY(0)';
                     e.currentTarget.style.boxShadow = '0 12px 32px rgba(251, 191, 36, 0.6), 0 0 20px rgba(251, 191, 36, 0.3)';
                   }}
                 >
                   無料で始める（1分で完了）
                 </button>
               </div>
               
               {/* ✅ 見守りではなく、楽しみから - 画像版 */}
               <img 
                 src={process.env.PUBLIC_URL + "/step3.png"} 
                 alt="見守りではなく、楽しみから始まります"
                 style={{ 
                   width: '100%',
                   maxWidth: '600px',
                   margin: '0 auto 32px auto',
                   display: 'block',
                   borderRadius: '12px',
                   boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
                 }}
               />

               {/* ✅ ソエルが選ばれる理由 - コンパクト版 */}
               <div style={{
                 background: 'white',
                 borderRadius: '16px',
                 padding: '24px 20px',
                 margin: '0 auto 32px auto',
                 maxWidth: '600px',
                 border: '2px solid #e5e7eb'
               }}>
                 <h2 style={{
                   fontSize: '20px',
                   fontWeight: 'bold',
                   color: '#1e293b',
                   textAlign: 'center',
                   marginBottom: '20px'
                 }}>
                   ⭐ ソエルが選ばれる理由
                 </h2>
                 
                 <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                   {/* 監視感 */}
                   <div style={{
                     display: 'grid',
                     gridTemplateColumns: '80px 1fr 1fr',
                     gap: '10px',
                     alignItems: 'center',
                     padding: '10px',
                     background: '#f8fafc',
                     borderRadius: '8px'
                   }}>
                     <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#64748b', textAlign: 'center' }}>
                       <div style={{ fontSize: '28px', marginBottom: '2px' }}>👁️</div>
                       監視感
                     </div>
                     <div style={{
                       textAlign: 'center',
                       padding: '8px',
                       background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)',
                       borderRadius: '6px',
                       border: '2px solid #10b981'
                     }}>
                       <div style={{ fontSize: '11px', color: '#065f46', marginBottom: '4px', fontWeight: 'bold' }}>ソエル</div>
                       <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#059669', whiteSpace: 'nowrap' }}>◎ ない</div>
                     </div>
                     <div style={{
                       textAlign: 'center',
                       padding: '8px',
                       background: 'white',
                       borderRadius: '6px',
                       border: '1px solid #e5e7eb'
                     }}>
                       <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px' }}>一般的な見守り</div>
                       <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#dc2626', whiteSpace: 'nowrap' }}>❌ ある</div>
                     </div>
                   </div>
                   
                   {/* 親の楽しさ */}
                   <div style={{
                     display: 'grid',
                     gridTemplateColumns: '80px 1fr 1fr',
                     gap: '10px',
                     alignItems: 'center',
                     padding: '10px',
                     background: '#f8fafc',
                     borderRadius: '8px'
                   }}>
                     <div style={{ fontSize: '13px', fontWeight: 'bold', color: '#64748b', textAlign: 'center' }}>
                       <div style={{ fontSize: '28px', marginBottom: '2px' }}>😊</div>
                       親の楽しさ
                     </div>
                     <div style={{
                       textAlign: 'center',
                       padding: '8px',
                       background: 'linear-gradient(135deg, #ecfdf5, #d1fae5)',
                       borderRadius: '6px',
                       border: '2px solid #10b981'
                     }}>
                       <div style={{ fontSize: '11px', color: '#065f46', marginBottom: '4px', fontWeight: 'bold' }}>ソエル</div>
                       <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#059669', whiteSpace: 'nowrap' }}>◎ 高い</div>
                     </div>
                     <div style={{
                       textAlign: 'center',
                       padding: '8px',
                       background: 'white',
                       borderRadius: '6px',
                       border: '1px solid #e5e7eb'
                     }}>
                       <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px' }}>一般的な見守り</div>
                       <div style={{ fontSize: '15px', fontWeight: 'bold', color: '#64748b', whiteSpace: 'nowrap' }}>△ 低い</div>
                     </div>
                   </div>
                 </div>
               </div>

               {/* ✅ 利用者の声 - コンパクト版 */}
               <div style={{
                 background: 'linear-gradient(135deg, #fff7ed, #ffedd5)',
                 borderRadius: '16px',
                 padding: '24px 20px',
                 margin: '0 auto 32px auto',
                 maxWidth: '600px',
                 border: '2px solid #fed7aa'
               }}>
                 <h2 style={{
                   fontSize: '20px',
                   fontWeight: 'bold',
                   color: '#9a3412',
                   textAlign: 'center',
                   marginBottom: '16px'
                 }}>
                   💬 利用者の声
                 </h2>
                 
                 <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                   <div style={{
                     background: 'white',
                     borderRadius: '10px',
                     padding: '12px',
                     boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)'
                   }}>
                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                       <div style={{ fontSize: '24px' }}>👨</div>
                       <div style={{ fontSize: '12px', color: '#64748b' }}>50代男性・息子</div>
                     </div>
                     <div style={{ fontSize: '15px', color: '#1e293b', lineHeight: '1.5' }}>
                       母が毎日<span style={{ color: '#ea580c', fontWeight: 'bold' }}>楽しみ</span>にしています
                     </div>
                   </div>
                   
                   <div style={{
                     background: 'white',
                     borderRadius: '10px',
                     padding: '12px',
                     boxShadow: '0 2px 6px rgba(0, 0, 0, 0.06)'
                   }}>
                     <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '6px' }}>
                       <div style={{ fontSize: '24px' }}>👩</div>
                       <div style={{ fontSize: '12px', color: '#64748b' }}>40代女性・娘</div>
                     </div>
                     <div style={{ fontSize: '15px', color: '#1e293b', lineHeight: '1.5' }}>
                       電話しなくても<span style={{ color: '#ea580c', fontWeight: 'bold' }}>安心感</span>は増えました ✨
                     </div>
                   </div>
                 </div>
               </div>

               {/* ✅ 最終メッセージ - コンパクト版 */}
               <div style={{
                 textAlign: 'center',
                 padding: '24px 20px',
                 margin: '0 auto 24px auto',
                 maxWidth: '600px'
               }}>
                 <div style={{
                   fontSize: '24px',
                   fontWeight: 'bold',
                   color: '#1e293b',
                   marginBottom: '16px',
                   lineHeight: '1.5'
                 }}>
                   "<span style={{ color: '#64748b' }}>何もない</span><span style={{ color: '#ea580c' }}>毎日</span>"を、今日から。
                 </div>
                 <img 
                   src={process.env.PUBLIC_URL + "/logo.png"} 
                   alt="SOERU"
                   style={{ 
                     maxWidth: '240px',
                     height: 'auto',
                     display: 'block',
                     margin: '0 auto 8px auto'
                   }}
                 />
               </div>

               {/* ✅ CTA - 親の「今日も元気だよ」が何よりの安心になる */}
               <div style={{
                 background: 'linear-gradient(135deg, #ea580c, #c2410c)',
                 borderRadius: '16px',
                 padding: '32px 24px',
                 margin: '0 auto 32px auto',
                 maxWidth: '600px',
                 textAlign: 'center',
                 boxShadow: '0 8px 24px rgba(234, 88, 12, 0.3)'
               }}>
                 <div style={{
                   fontSize: '22px',
                   fontWeight: 'bold',
                   color: 'white',
                   marginBottom: '8px',
                   lineHeight: '1.5'
                 }}>
                   親の「今日も元気だよ」が<br />
                   何よりの安心になる。
                 </div>
                 <div style={{
                   fontSize: '14px',
                   color: 'rgba(255, 255, 255, 0.9)',
                   marginBottom: '24px'
                 }}>
                   もしもの前に、今日から始めませんか？
                 </div>
                 
                 <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                   <button
                     onClick={() => setRegistrationStep('role-select')}
                     style={{
                       background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                       border: '4px solid #fbbf24',
                       borderRadius: '16px',
                       padding: '20px 32px',
                       fontSize: '22px',
                       fontWeight: 'bold',
                       color: 'white',
                       cursor: 'pointer',
                       boxShadow: '0 10px 28px rgba(251, 191, 36, 0.6), 0 0 16px rgba(251, 191, 36, 0.3)',
                       transition: 'all 0.3s ease',
                       textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
                     }}
                     onMouseOver={(e) => {
                       e.currentTarget.style.transform = 'translateY(-4px)';
                       e.currentTarget.style.boxShadow = '0 14px 36px rgba(251, 191, 36, 0.7), 0 0 24px rgba(251, 191, 36, 0.4)';
                     }}
                     onMouseOut={(e) => {
                       e.currentTarget.style.transform = 'translateY(0)';
                       e.currentTarget.style.boxShadow = '0 10px 28px rgba(251, 191, 36, 0.6), 0 0 16px rgba(251, 191, 36, 0.3)';
                     }}
                   >
                     無料で始める<br />
                     （1分で完了）
                   </button>
                 </div>
               </div>

                {/* ✅ このデバイスでログイン */}
                {users.length > 0 && (() => {
                  const savedUserId = localStorage.getItem('currentUserId');
                  const foundUser = users.find(u => u.id === savedUserId);
                  
                  if (!foundUser) return null;
                  
                  return (
                    <div style={{
                      marginTop: '40px',
                      padding: '20px',
                      background: '#f0f9ff',
                      border: '2px solid #3b82f6',
                      borderRadius: '12px',
                      maxWidth: '600px',
                      margin: '40px auto 0 auto'
                    }}>
                      <h3 style={{ 
                        fontSize: '16px', 
                        fontWeight: 'bold', 
                        marginBottom: '12px',
                        color: '#1e40af',
                        textAlign: 'center'
                      }}>
                        このデバイスでログイン
                      </h3>
                      <button
                        onClick={() => handleLogin(foundUser.id)}
                        style={{
                          width: '100%',
                          padding: '16px',
                          fontSize: '16px',
                          background: '#3b82f6',
                          color: 'white',
                          border: 'none',
                          borderRadius: '8px',
                          cursor: 'pointer',
                          fontWeight: 'bold'
                        }}
                      >
                        {foundUser.name} ({foundUser.role === 'parent' ? 'メイン' : 'サポート'})
                      </button>
                    </div>
                  );
                })()}

                {/* ✅ 招待コードでログイン */}
                <div style={{
                  marginTop: '40px',
                  padding: '20px',
                  background: '#f0fdf4',
                  border: '2px solid #10b981',
                  borderRadius: '12px',
                  maxWidth: '600px',
                  margin: '40px auto 0 auto'
                }}>
                  <h3 style={{ 
                    fontSize: '16px', 
                    fontWeight: 'bold', 
                    marginBottom: '12px',
                    color: '#166534',
                    textAlign: 'center'
                  }}>
                    📱 招待コードでログイン
                  </h3>
                  <p style={{ 
                    fontSize: '13px', 
                    color: '#166534', 
                    marginBottom: '12px',
                    textAlign: 'center'
                  }}>
                    他の端末で登録済みの方は、<br />
                    招待コードでログインできます
                  </p>
                  <input
                    type="text"
                    value={inviteCodeInput}
                    onChange={(e) => {
                      const value = e.target.value.replace(/[^0-9]/g, '');
                      setInviteCodeInput(value);
                    }}
                    placeholder="1234"
                    maxLength={4}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    style={{
                      width: '100%',
                      padding: '12px',
                      fontSize: '24px',
                      border: '2px solid #10b981',
                      borderRadius: '8px',
                      marginBottom: '12px',
                      textAlign: 'center',
                      letterSpacing: '8px',
                      fontWeight: 'bold'
                    }}
                  />
                  <button
                    onClick={() => handleInviteCodeLogin(inviteCodeInput)}
                    style={{
                      width: '100%',
                      padding: '12px',
                      background: '#10b981',
                      color: 'white',
                      border: 'none',
                      borderRadius: '8px',
                      cursor: 'pointer',
                      fontSize: '16px',
                      fontWeight: 'bold'
                    }}
                  >
                    ログイン
                  </button>
                </div>

        {/* ✅ 端末注意 */}
                <div style={{
                  marginTop: '40px',
                  padding: '16px',
                  background: '#fef3c7',
                  border: '2px solid #f59e0b',
                  borderRadius: '12px',
                  fontSize: '13px',
                  color: '#92400e',
                  lineHeight: '1.8'
                }}>
                  <p style={{ margin: '0 0 12px 0', fontWeight: 'bold', fontSize: '14px' }}>
                    ⚠️ 当アプリはAndroid端末推奨です
                  </p>
                  <div style={{ marginBottom: '8px' }}>
                    <strong>◆ Apple社製品（iPhone・iPad）：</strong>
                    <ul style={{ margin: '4px 0 0 20px', paddingLeft: 0 }}>
                      <li>無料お試しプランは音声が出ません</li>
                      <li>有料プランでも、AI動作が不安定な為、音声が出ない等の不具合が生じることがあります</li>
                    </ul>
                  </div>
                  <div>
                    <strong>◆ Fireタブレット等：</strong>
                    <ul style={{ margin: '4px 0 0 20px', paddingLeft: 0 }}>
                      <li>「ソエルに話しかける」ボタンの音声が再生されない恐れがあります</li>
                    </ul>
                     <p style={{ margin: '8px 0 0 0', fontSize: '12px' }}>
    ※一部端末ではマイクの設定状況により、「ソエルに話しかける」ボタンの音声が認識されない場合があります
  </p>
                  </div>
                </div>

                {/* ✅ 料金プラン */}
                <div style={{
                  marginTop: '32px',
                  padding: '24px 20px',
                  background: 'linear-gradient(135deg, #f7fee7, #ecfccb)',
                  borderRadius: '12px',
                  border: '2px solid #a3e635'
                }}>
                  <h2 style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#4d7c0f',
                    marginBottom: '16px',
                    textAlign: 'center'
                  }}>
                    💰 料金プラン
                  </h2>
                  
                  {/* 無料プラン */}
                  <div style={{
                    background: 'white',
                    border: '2px solid #d9f99d',
                    borderRadius: '10px',
                    padding: '14px',
                    marginBottom: '10px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                      <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#3f6212' }}>
                        🎁 無料お試しプラン
                      </div>
                      <div style={{
                        background: '#fef3c7',
                        color: '#92400e',
                        padding: '4px 12px',
                        borderRadius: '999px',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>
                        ¥0
                      </div>
                    </div>
                    <div style={{ fontSize: '12px', color: '#78716c', lineHeight: '1.7' }}>
                      1日3回まで・看護師風の話し方
                    </div>
                  </div>

                  {/* ベーシックプラン */}
                  <div style={{
                    background: 'linear-gradient(135deg, #fff7ed, #ffedd5)',
                    border: '3px solid #fb923c',
                    borderRadius: '10px',
                    padding: '14px',
                    marginBottom: '10px',
                    position: 'relative'
                  }}>
                    <div style={{
                      position: 'absolute',
                      top: '-10px',
                      right: '12px',
                      background: 'linear-gradient(135deg, #fb923c, #f97316)',
                      color: 'white',
                      padding: '3px 10px',
                      borderRadius: '999px',
                      fontSize: '10px',
                      fontWeight: 'bold'
                    }}>
                      ⭐ 人気
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                      <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#7c2d12' }}>
                        ✨ ベーシックプラン
                      </div>
                      <div style={{
                        background: '#fb923c',
                        color: 'white',
                        padding: '4px 12px',
                        borderRadius: '999px',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>
                        ¥480/月
                      </div>
                    </div>
                    <div style={{ fontSize: '12px', color: '#78716c', lineHeight: '1.7' }}>
                      1日7回まで・5種類の話し方
                    </div>
                  </div>

                  {/* バリュープラン */}
                  <div style={{
                    background: 'white',
                    border: '2px solid #fde68a',
                    borderRadius: '10px',
                    padding: '14px'
                  }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '8px' }}>
                      <div style={{ fontSize: '14px', fontWeight: 'bold', color: '#713f12' }}>
                        🌟 バリュープラン
                      </div>
                      <div style={{
                        background: '#84cc16',
                        color: 'white',
                        padding: '4px 12px',
                        borderRadius: '999px',
                        fontSize: '12px',
                        fontWeight: 'bold'
                      }}>
                        ¥980/月
                      </div>
                    </div>
                    <div style={{ fontSize: '12px', color: '#78716c', lineHeight: '1.7' }}>
                      1日15回まで・5種類の話し方
                    </div>
                  </div>
                </div>

                {/* ✅ QRコードはこちら */}
                <div style={{
                  marginTop: '24px',
                  padding: '24px 20px',
                  background: 'linear-gradient(135deg, #fefce8, #fef3c7)',
                  borderRadius: '16px',
                  border: '3px solid #fbbf24',
                  maxWidth: '600px',
                  margin: '24px auto 0 auto'
                }}>
                  <h2 style={{
                    fontSize: '18px',
                    fontWeight: 'bold',
                    color: '#713f12',
                    marginBottom: '8px',
                    textAlign: 'center'
                  }}>
                    📱 QRコードはこちら
                  </h2>
                  <p style={{
                    fontSize: '13px',
                    color: '#78716c',
                    textAlign: 'center',
                    marginBottom: '16px',
                    lineHeight: '1.6'
                  }}>
                    このQRコードを読み取って<br />
                    アプリにアクセスできます
                  </p>
                  <div style={{
                    background: 'white',
                    borderRadius: '12px',
                    padding: '24px',
                    textAlign: 'center'
                  }}>
                    <img 
                      src={process.env.PUBLIC_URL + "/qr-code.png"} 
                      alt="SOERU QRコード"
                      style={{
                        width: '200px',
                        height: '200px',
                        margin: '0 auto',
                        display: 'block'
                      }}
                    />
                  </div>
                </div>

                {/* ✅ アプリのように使うには - コンパクト版 */}
                <div style={{
                  marginTop: '20px',
                  padding: '20px',
                  background: 'linear-gradient(135deg, #eff6ff, #dbeafe)',
                  borderRadius: '12px',
                  border: '2px solid #60a5fa',
                  maxWidth: '600px',
                  margin: '20px auto 40px auto'
                }}>
                  <h2 style={{
                    fontSize: '16px',
                    fontWeight: 'bold',
                    color: '#1e40af',
                    marginBottom: '12px',
                    textAlign: 'center'
                  }}>
                    📱 アプリのように使うには
                  </h2>
                  
                  <div style={{
                    fontSize: '12px',
                    color: '#1e3a8a',
                    marginBottom: '12px',
                    textAlign: 'center',
                    lineHeight: '1.6'
                  }}>
                    ホームに追加してください（次回より簡単ログイン）
                  </div>

                  {/* 3ステップ - コンパクト */}
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(3, 1fr)',
                    gap: '8px'
                  }}>
                    <div style={{
                      background: 'white',
                      borderRadius: '8px',
                      padding: '12px 8px',
                      textAlign: 'center',
                      border: '2px solid #10b981'
                    }}>
                      <div style={{
                        background: '#10b981',
                        color: 'white',
                        width: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        margin: '0 auto 8px auto'
                      }}>1</div>
                      <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#065f46', marginBottom: '6px' }}>
                        ソエルページを<br />開いた状態で
                      </div>
                      <div style={{ fontSize: '32px' }}>🌐</div>
                    </div>

                    <div style={{
                      background: 'white',
                      borderRadius: '8px',
                      padding: '12px 8px',
                      textAlign: 'center',
                      border: '2px solid #10b981'
                    }}>
                      <div style={{
                        background: '#10b981',
                        color: 'white',
                        width: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        margin: '0 auto 8px auto'
                      }}>2</div>
                      <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#065f46', marginBottom: '6px' }}>
                        右上の「︙」を<br />タップ
                      </div>
                      <div style={{ fontSize: '32px' }}>⋮</div>
                    </div>

                    <div style={{
                      background: 'white',
                      borderRadius: '8px',
                      padding: '12px 8px',
                      textAlign: 'center',
                      border: '2px solid #10b981'
                    }}>
                      <div style={{
                        background: '#10b981',
                        color: 'white',
                        width: '28px',
                        height: '28px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        margin: '0 auto 8px auto'
                      }}>3</div>
                      <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#065f46', marginBottom: '6px' }}>
                        「ホーム画面に追加」
                      </div>
                      <div style={{ fontSize: '32px' }}>📲</div>
                    </div>
                  </div>
                </div>

                  </>  
            )}

            {/* ✅ 役割選択画面 */}
            {registrationStep === 'role-select' && (
              <>
                <div style={{
                  maxWidth: '600px',
                  margin: '40px auto',
                  padding: '40px 24px',
                  background: 'white',
                  borderRadius: '20px',
                  boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)'
                }}>
                  <h2 style={{
                    fontSize: '24px',
                    fontWeight: 'bold',
                    color: '#1e293b',
                    marginBottom: '8px',
                    textAlign: 'center'
                  }}>
                    どちらで利用しますか？
                  </h2>
                  
                  <p style={{
                    fontSize: '14px',
                    color: '#64748b',
                    marginBottom: '32px',
                    textAlign: 'center',
                    lineHeight: '1.6'
                  }}>
                    あなたの役割を選んでください<br />
                    <span style={{ fontSize: '12px', color: '#94a3b8' }}>
                      ※どちらが先に登録してもOKです
                    </span>
                  </p>
                  
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px' }}>
                    {/* メインで使用する人 */}
                    <button
                      onClick={() => setRegistrationStep('main')}
                      style={{
                        background: 'linear-gradient(135deg, #f0fdf4, #dcfce7)',
                        border: '3px solid #84cc16',
                        borderRadius: '16px',
                        padding: '32px 24px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        textAlign: 'center'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(132, 204, 22, 0.3)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      <div style={{ fontSize: '48px', marginBottom: '16px' }}>👤</div>
                      <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#166534', marginBottom: '12px' }}>
                        メインで使用する人
                      </div>
                      <div style={{ fontSize: '14px', color: '#15803d', lineHeight: '1.6' }}>
                        体調管理をする本人として利用<br />
                        AIと会話して楽しく健康管理
                      </div>
                    </button>

                    {/* サポート・見守る人 */}
                    <button
                      onClick={() => setRegistrationStep('support')}
                      style={{
                        background: 'linear-gradient(135deg, #fff7ed, #ffedd5)',
                        border: '3px solid #fb923c',
                        borderRadius: '16px',
                        padding: '32px 24px',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        textAlign: 'center'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-4px)';
                        e.currentTarget.style.boxShadow = '0 8px 24px rgba(251, 146, 60, 0.3)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      <div style={{ fontSize: '48px', marginBottom: '16px' }}>👨‍👩‍👧</div>
                      <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#9a3412', marginBottom: '12px' }}>
                        サポート・見守る人
                      </div>
                      <div style={{ fontSize: '14px', color: '#c2410c', lineHeight: '1.6' }}>
                        家族など、見守りサポートとして利用<br />
                        後から招待コードで紐付けできます
                      </div>
                    </button>
                  </div>

                  <button
                    onClick={() => setRegistrationStep('select')}
                    style={{
                      marginTop: '24px',
                      background: 'transparent',
                      border: 'none',
                      color: '#94a3b8',
                      fontSize: '14px',
                      cursor: 'pointer',
                      width: '100%',
                      textAlign: 'center',
                      padding: '12px'
                    }}
                  >
                    ← 戻る
                  </button>
                </div>
              </>
            )}
               
            {/* メイン使用者の登録画面 */}
            {registrationStep === 'main' && (
              <div>
                <button
                  onClick={() => setRegistrationStep('select')}
                  style={{
                    padding: '8px 16px',
                    marginBottom: '16px',
                    background: '#f1f5f9',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer'
                  }}
                >
                  ← 戻る
                </button>
                <h2 className="section-title">メイン使用者の登録</h2>
                <div style={{ maxWidth: '400px', margin: '0 auto' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px' }}>
                    お名前
                  </label>
                  <input
                    type="text"
                    value={registrationName}
                    onChange={(e) => setRegistrationName(e.target.value)}
                    placeholder="山田 太郎"
                    style={{
                      width: '100%',
                      padding: '12px',
                      fontSize: '16px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '8px',
                      marginBottom: '20px'
                    }}
                  />
                     {/* ← ここから郵便番号入力を追加 */}
                 <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px' }}>
  郵便番号（任意）
</label>
<p style={{ fontSize: '12px', color: '#64748b', marginTop: '-4px', marginBottom: '8px' }}>
  ※イベント情報・会話等に使用します
</p>
                  <input
                    type="text"
                    value={postalCode}
                    onChange={handlePostalCodeChange}
                    placeholder="857-0001"
                    maxLength="8"
                    style={{
                      width: '100%',
                      padding: '12px',
                      fontSize: '16px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '8px',
                      marginBottom: '12px'
                    }}
                  />
                  
                  {(prefecture || city) && (
                    <div style={{ 
                      padding: '12px', 
                      background: '#f0f9ff', 
                      border: '1px solid #bae6fd',
                      borderRadius: '8px', 
                      marginBottom: '20px',
                      fontSize: '14px',
                      color: '#0369a1'
                    }}>
                      📍 {prefecture} {city}
                    </div>
                  )}
                  {/* ← ここまで追加 */}

                  {/* ✅ 招待コード入力（任意） */}
                  <div style={{
                    marginTop: '12px',
                    padding: '16px',
                    background: '#f0f9ff',
                    border: '2px solid #3b82f6',
                    borderRadius: '12px'
                  }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px', color: '#1e40af', fontWeight: 'bold' }}>
                      招待コード（任意）
                    </label>
                    <p style={{ fontSize: '13px', color: '#1e40af', marginTop: '-4px', marginBottom: '12px', lineHeight: '1.6' }}>
                      サポート側が先に登録している場合、<br />
                      招待コードを入力してください（リンクできます）
                    </p>
                    <input
                      type="text"
                      value={inviteCode}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        setInviteCode(value);
                      }}
                      placeholder="1234"
                      maxLength="4"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '20px',
                        border: '2px solid #3b82f6',
                        borderRadius: '8px',
                        textAlign: 'center',
                        letterSpacing: '4px',
                        fontWeight: 'bold'
                      }}
                    />
                  </div>

{/* ✅ 利用規約 */}
                  <div style={{
                    padding: '12px',
                    background: '#fef3c7',
                    border: '1px solid #fbbf24',
                    borderRadius: '8px',
                    marginBottom: '16px',
                    fontSize: '12px',
                    color: '#92400e',
                    lineHeight: '1.6'
                  }}>
                    <p style={{ margin: '0 0 8px 0', fontWeight: 'bold' }}>⚠️ ご利用にあたって</p>
                    <ul style={{ margin: 0, paddingLeft: '20px' }}>
                      <li>本サービスのAIは誤りを含む可能性があります</li>
                      <li>医療行為や緊急時の判断には使用しないでください</li>
                      <li>体調不良時は医療機関を受診してください</li>
                      <li>緊急時は119番に連絡してください</li>
                    </ul>
                  </div>

                  <button
                    onClick={registerMainUser}
                    className="status-button good"
                    style={{ width: '100%', padding: '16px', fontSize: '18px' }}
                  >
                    利用規約に同意して登録する
                  </button>
                  <p style={{ marginTop: '16px', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
                    招待コードを入力しない場合、新しい招待コードが発行されます。<br />
                    後からサポート側がそのコードで紐付けできます。
                  </p>
                   {/* ✅ ホーム画面に追加の案内 */}
                  <div style={{
                    marginTop: '32px',
                    padding: '20px',
                    background: '#eff6ff',
                    border: '2px solid #3b82f6',
                    borderRadius: '12px'
                  }}>
                    <h3 style={{ 
                      fontSize: '16px', 
                      fontWeight: 'bold', 
                      marginBottom: '12px',
                      color: '#1e40af',
                      textAlign: 'center'
                    }}>
                      📱 アプリのように使うには
                    </h3>
                    <img 
                      src={process.env.PUBLIC_URL + "/Gemini_Generated_Image_4aappy4aappy4aap.png"}
                      alt="ホーム画面に追加"
                      style={{ 
                        width: '100%',
  display: 'block',
  borderRadius: '8px'
                      }}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* サポーターの登録画面 */}
            {registrationStep === 'support' && (
              <div>
                <button
                  onClick={() => setRegistrationStep('select')}
                  style={{
                    padding: '8px 16px',
                    marginBottom: '16px',
                    background: '#f1f5f9',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer'
                  }}
                >
                  ← 戻る
                </button>
                <h2 className="section-title">サポーターの登録</h2>
                <p style={{ 
  fontSize: '13px', 
  color: '#64748b', 
  textAlign: 'center',
  margin: '8px 0 20px 0',
  lineHeight: '1.6'
}}>
  登録すると画面下部の履歴より、最近の状況をご確認いただけます
</p>
                <div style={{ maxWidth: '400px', margin: '0 auto' }}>
                  <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px' }}>
                    お名前
                  </label>
                  <input
                    type="text"
                    value={registrationName}
                    onChange={(e) => setRegistrationName(e.target.value)}
                    placeholder="山田 花子"
                    style={{
                      width: '100%',
                      padding: '12px',
                      fontSize: '16px',
                      border: '2px solid #e2e8f0',
                      borderRadius: '8px',
                      marginBottom: '20px'
                    }}
                  />
                  
                  <div style={{
                    marginTop: '12px',
                    padding: '16px',
                    background: '#fef3c7',
                    border: '2px solid #f59e0b',
                    borderRadius: '12px'
                  }}>
                    <label style={{ display: 'block', marginBottom: '8px', fontSize: '16px', color: '#92400e', fontWeight: 'bold' }}>
                      招待コード（任意）
                    </label>
                    <p style={{ fontSize: '13px', color: '#92400e', marginTop: '-4px', marginBottom: '12px', lineHeight: '1.6' }}>
                      メイン側が先に登録している場合、<br />
                      招待コードを入力してください（情報を共有できます）
                    </p>
                    <input
                      type="text"
                      value={inviteCode}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9]/g, '');
                        setInviteCode(value);
                      }}
                      placeholder="1234"
                      maxLength="4"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      style={{
                        width: '100%',
                        padding: '12px',
                        fontSize: '20px',
                        textAlign: 'center',
                        letterSpacing: '4px',
                        border: '2px solid #f59e0b',
                        borderRadius: '8px',
                        fontWeight: 'bold'
                      }}
                    />
                  </div>
                  
                  <button
                    onClick={registerSupportUser}
                    className="status-button normal"
                    style={{ width: '100%', padding: '16px', fontSize: '18px' }}
                  >
                    登録する
                  </button>
                  <p style={{ marginTop: '16px', fontSize: '14px', color: '#64748b', textAlign: 'center' }}>
                    招待コードを入力しない場合、新しい招待コードが発行されます。<br />
                    後からメイン使用者がそのコードで紐付けできます。
                  </p>
                    {/* ✅ ホーム画面に追加の案内 */}
                  <div style={{
                    marginTop: '32px',
                    padding: '20px',
                    background: '#eff6ff',
                    border: '2px solid #3b82f6',
                    borderRadius: '12px'
                  }}>
                    <h3 style={{ 
                      fontSize: '16px', 
                      fontWeight: 'bold', 
                      marginBottom: '12px',
                      color: '#1e40af',
                      textAlign: 'center'
                    }}>
                      📱 アプリのように使うには
                    </h3>
                    <img 
                      src={process.env.PUBLIC_URL + "/Gemini_Generated_Image_4aappy4aappy4aap.png"}
                      alt="ホーム画面に追加"
                      style={{ 
                        width: '100%',
  display: 'block',
  borderRadius: '8px'
                      }}
                    />
                    </div>
                </div>
              </div>
            )}
          </div>
        </div>
 {/* ✅ 特定商取引法 */}
<div style={{
  padding: '16px',
  background: '#f8fafc',
  borderTop: '1px solid #e2e8f0'
}}>
  <button
    onClick={() => setShowTokuhoText(!showTokuhoText)}
    style={{
      width: '100%',
      padding: '12px',
      background: '#3b82f6',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '14px',
      fontWeight: 'bold',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '8px'
    }}
  >
    特定商取引法に基づく表記
    <span>{showTokuhoText ? '▲' : '▼'}</span>
  </button>
  
  {/* ボタンを押すと下に表示 */}
  {showTokuhoText && (
    <div style={{
      marginTop: '16px',
      padding: '16px',
      background: 'white',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      fontSize: '12px',
      lineHeight: '1.6'
    }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
         <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
  <td style={{ padding: '8px', fontWeight: 'bold', width: '35%' }}>サービス名</td>
  <td style={{ padding: '8px' }}>SOERU（ソエル）</td>
</tr>
<tr style={{ borderBottom: '1px solid #e2e8f0' }}>
  <td style={{ padding: '8px', fontWeight: 'bold' }}>事業者名</td>
  <td style={{ padding: '8px' }}>SOERU 運営事務局</td>
</tr>
<tr style={{ borderBottom: '1px solid #e2e8f0' }}>
  <td style={{ padding: '8px', fontWeight: 'bold' }}>運営責任者</td>
  <td style={{ padding: '8px' }}>冨岡 泰裕</td>
</tr>
<tr style={{ borderBottom: '1px solid #e2e8f0' }}>
  <td style={{ padding: '8px', fontWeight: 'bold' }}>所在地</td>
  <td style={{ padding: '8px' }}>長崎県佐世保市<br /><span style={{ fontSize: '10px' }}>※請求があった場合には、遅滞なく開示いたします。</span></td>
</tr>
<tr style={{ borderBottom: '1px solid #e2e8f0' }}>
  <td style={{ padding: '8px', fontWeight: 'bold' }}>電話番号</td>
  <td style={{ padding: '8px' }}><span style={{ fontSize: '10px' }}>※請求があった場合には、遅滞なく開示いたします。</span></td>
</tr>
<tr style={{ borderBottom: '1px solid #e2e8f0' }}>
  <td style={{ padding: '8px', fontWeight: 'bold' }}>メール</td>
  <td style={{ padding: '8px' }}>leefria1119@hotmail.com</td>
</tr>
         <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
  <td style={{ padding: '8px', fontWeight: 'bold' }}>販売価格</td>
  <td style={{ padding: '8px' }}>
    無料お試しプラン: 0円<br />
    ベーシックプラン: 490円/月（税込）<br />
    バリュープラン: 980円/月（税込）
  </td>
</tr>
         <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
  <td style={{ padding: '8px', fontWeight: 'bold' }}>支払方法</td>
  <td style={{ padding: '8px' }}>クレジットカード（Stripe）</td>
</tr>
          <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
            <td style={{ padding: '8px', fontWeight: 'bold' }}>提供時期</td>
            <td style={{ padding: '8px' }}>登録後即時利用可能</td>
          </tr>
          <tr style={{ borderBottom: '1px solid #e2e8f0' }}>
  <td style={{ padding: '8px', fontWeight: 'bold' }}>支払時期</td>
  <td style={{ padding: '8px' }}>有料プラン登録時即時決済、以降毎月自動更新</td>
</tr>
          <tr>
  <td style={{ padding: '8px', fontWeight: 'bold' }}>返金・キャンセル</td>
  <td style={{ padding: '8px' }}>月の途中での解約・プラン変更時の日割り返金はございません。解約日まで利用可能です。</td>
</tr>
        </tbody>
      </table>
      <p style={{ fontSize: '10px', marginTop: '12px', color: '#64748b', textAlign: 'center' }}>
        制定日: 2025年12月26日
      </p>
    </div>
  )}
</div>
        {/* ✅ ここに免責事項を追加 */}
        <div style={{
          padding: '16px',
          background: '#f8fafc',
          borderTop: '1px solid #e2e8f0',
          textAlign: 'center',
          fontSize: '11px',
          color: '#64748b',
          lineHeight: '1.4',
          marginTop: '20px'
        }}>
          <p style={{ margin: 0 }}>
            ⚠️ 本サービスのAIは誤りを含む可能性があります。<br />
            医療行為や緊急時の判断には使用しないでください。
          </p>
        </div>
      </div>
    );
  }
  
  return (
  <div className="app">
  {isLoading && (
  <div className="loading-banner">
    <div className="loading-spinner"></div>
    <p>考え中... 少々お待ちください</p>
  </div>
)}
{showMessage && (
  <div className="message-overlay" onClick={stopConversation}>
    <div className="message-box" onClick={(e) => e.stopPropagation()}>
      
      <div className="message-header">
        <img 
          src={`${process.env.PUBLIC_URL}/characters/${selectedCharacter}.jpg`}
          alt={CHARACTER_PROMPTS[selectedCharacter]?.label}
          className="message-avatar"
        />
        <h3>{CHARACTER_PROMPTS[selectedCharacter]?.label}からのメッセージ</h3>
      </div>
      <p className="message-text">{claudeMessage}</p>

      <button className="close-button" onClick={stopConversation}>
        閉じる
      </button>
    </div>
  </div>
)}

{/* ✅ ホーム追加案内モーダル */}
{showHomeAddGuide && (
  <div className="message-overlay" onClick={() => setShowHomeAddGuide(false)}>
    <div className="message-box" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
      <h2 style={{ marginBottom: '16px', fontSize: '20px', fontWeight: 'bold', textAlign: 'center' }}>
        📱 ホーム画面に追加して<br />アプリのように使おう
      </h2>
      
      <img 
        src={process.env.PUBLIC_URL + "/Gemini_Generated_Image_4aappy4aappy4aap.png"}
        alt="ホーム画面に追加"
        style={{ 
          width: '100%',
          borderRadius: '8px',
          marginBottom: '16px'
        }}
      />
      
      <button 
        className="close-button" 
        onClick={() => setShowHomeAddGuide(false)}
        style={{ width: '100%' }}
      >
        閉じる
      </button>
    </div>
  </div>
)}



          {/* ✅ 招待履歴モーダル */}
    {showInviteHistory && (
      <div className="message-overlay" onClick={() => setShowInviteHistory(false)}>
        <div className="message-box" onClick={(e) => e.stopPropagation()}>
          <h3>招待履歴</h3>
          {invitedUsers.length > 0 ? (
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {invitedUsers.map((user, index) => (
                <div
                  key={index}
                  style={{
                    padding: '12px',
                    borderBottom: '1px solid #e2e8f0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 'bold', fontSize: '16px' }}>
                      {user.name}
                    </div>
                    <div style={{ fontSize: '12px', color: '#64748b' }}>
                      登録日: {new Date(user.created_at).toLocaleDateString('ja-JP')}
                    </div>
                  </div>
                  <span
                    style={{
                      padding: '4px 8px',
                      background: '#f0fdf4',
                      color: '#16a34a',
                      borderRadius: '4px',
                      fontSize: '12px'
                    }}
                  >
                    サポーター
                  </span>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              まだ誰も招待していません
            </p>
          )}
          <button className="close-button" onClick={() => setShowInviteHistory(false)}>
            閉じる
          </button>
        </div>
      </div>
    )}
{/* ✅ プラン変更モーダル */}
{showPlanChange && (
  <div className="message-overlay" onClick={() => setShowPlanChange(false)}>
    <div className="message-box" onClick={(e) => e.stopPropagation()}>
      <h3>プラン変更</h3>
      
      <div style={{ marginBottom: '20px' }}>
        <p style={{ fontSize: '14px', color: '#64748b' }}>
          {currentUser.role === 'parent' ? (
            <>
              現在のプラン: <span style={{ fontWeight: 'bold', color: '#1e293b' }}>
                {currentUser.plan === 'free' ? '無料プラン' : 
                 currentUser.plan === 'basic' ? 'ベーシックプラン' : 
                 currentUser.plan === 'value' ? 'バリュープラン' : '無料プラン'}
              </span>
            </>
          ) : (
            <>
              {parentData?.name}さんの現在のプラン: <span style={{ fontWeight: 'bold', color: '#1e293b' }}>
                {parentData?.plan === 'free' ? '無料プラン' : 
                 parentData?.plan === 'basic' ? 'ベーシックプラン' : 
                 parentData?.plan === 'value' ? 'バリュープラン' : '無料プラン'}
              </span>
            </>
          )}
        </p>
        {/* ✅ 注意書き追加 */}
        <div style={{
          padding: '8px 12px',
          background: '#fef3c7',
          border: '1px solid #fbbf24',
          borderRadius: '6px',
          fontSize: '12px',
          color: '#92400e',
          lineHeight: '1.5'
        }}>
          ⚠️ 途中で解約・変更された場合でも日割りの返金等はできません
        </div>
      </div>

      {/* ✅ サブスクリプション情報 */}
      {subscriptionInfo && (
        <div style={{ 
          marginBottom: '20px',
          padding: '16px', 
          background: '#f8fafc', 
          borderRadius: '8px',
          border: '1px solid #e2e8f0'
        }}>
          <h4 style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: '8px' }}>
            サービスご利用状況
            {subscriptionInfo.willCancel && (
              <span style={{ 
                marginLeft: '8px', 
                padding: '2px 8px', 
                background: '#fee2e2', 
                color: '#dc2626',
                borderRadius: '4px',
                fontSize: '11px',
                fontWeight: 'bold'
              }}>
                解約予約済み
              </span>
            )}
          </h4>
          
          <div style={{ fontSize: '13px', color: '#64748b', marginBottom: '12px' }}>
            {subscriptionInfo.willCancel ? (
              <div style={{ 
                padding: '12px', 
                background: '#fef2f2', 
                border: '2px solid #fca5a5',
                borderRadius: '8px'
              }}>
                <p style={{ 
                  color: '#dc2626', 
                  fontWeight: 'bold',
                  fontSize: '14px',
                  marginBottom: '8px'
                }}>
                  ⚠️ 解約予約済み
                </p>
                <p style={{ color: '#991b1b' }}>
                  {subscriptionInfo.cancelAt.toLocaleDateString('ja-JP', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                  に無料プランに戻ります
                </p>
              </div>
            ) : (
              <p>
                次回更新日: {subscriptionInfo.nextBillingDate.toLocaleDateString('ja-JP', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </p>
            )}
          </div>

          {!subscriptionInfo.willCancel ? (
            <button
              onClick={async () => {
                if (!window.confirm('本当に解約しますか？\n\n支払い済みの期間（' + 
                  subscriptionInfo.nextBillingDate.toLocaleDateString('ja-JP') + 
                  'まで）は引き続きご利用いただけます。')) {
                  return;
                }

                try {
                  const targetUserId = currentUser.role === 'parent' ? currentUser.id : currentUser.linked_user_id;
                  
                  const response = await fetch('/api/cancel-subscription', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ userId: targetUserId })
                  });

                  if (!response.ok) {
                    const errorText = await response.text();
                    alert('解約に失敗しました: ' + errorText);
                    return;
                  }

                  const data = await response.json();

                  if (data.success) {
                    const cancelDate = new Date(data.cancel_at * 1000);
                    const formattedDate = cancelDate.toLocaleDateString('ja-JP', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    });
                    
                    alert('解約を予約しました。' + formattedDate + 'まで引き続きご利用いただけます。');
                    
                    await fetchSubscriptionInfo();
                  } else {
                    alert('解約に失敗しました: ' + (data.error || '不明なエラー'));
                  }
                } catch (error) {
                  console.error('Cancel Error:', error);
                  alert('解約処理に失敗しました: ' + error.message);
                }
              }}
              
              style={{
                padding: '10px 16px',
                background: '#ef4444',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '13px',
                width: '100%'
              }}
            >
              解約する
            </button>
          ) : (
            <button
              onClick={async () => {
                if (!window.confirm('解約をキャンセルして、継続しますか？')) {
                  return;
                }

                try {
                  const response = await fetch('/api/reactivate-subscription', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ 
                      userId: currentUser.role === 'parent' ? currentUser.id : currentUser.linked_user_id 
                    })
                  });

                  const data = await response.json();

                  if (data.success) {
                    alert('サブスクリプションを継続します。');
                    await fetchSubscriptionInfo();
                  } else {
                    alert('継続処理に失敗しました: ' + (data.error || '不明なエラー'));
                  }
                } catch (error) {
                  console.error('Reactivate Error:', error);
                  alert('継続処理に失敗しました');
                }
              }}
              style={{
                padding: '10px 16px',
                background: '#10b981',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: 'pointer',
                fontSize: '13px',
                width: '100%'
              }}
            >
              解約をキャンセルして継続する
            </button>
          )}
        </div>
      )}

      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {/* 無料プラン */}
        <button
          onClick={() => {
            if (window.confirm('無料プランにダウングレードしますか？')) {
              changePlan('free');
            }
          }}
          disabled={currentUser.role === 'parent' ? currentUser.plan === 'free' : parentData?.plan === 'free'}
          style={{
            padding: '16px',
            background: currentUser.plan === 'free' ? '#e2e8f0' : '#f8fafc',
            border: currentUser.plan === 'free' ? '2px solid #3b82f6' : '2px solid #e2e8f0',
            borderRadius: '8px',
            cursor: currentUser.plan === 'free' ? 'not-allowed' : 'pointer',
            textAlign: 'left'
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px' }}>
            無料お試しプラン
          </div>
          <div style={{ fontSize: '14px', color: '#64748b' }}>
            • 1日3回まで利用可能<br />
            • 看護師風の話し方のみ<br />
            • ブラウザ音声
          </div>
          {/* ✅ 注意書き追加 */}
          <div style={{
            padding: '12px',
            background: '#fef3c7',
            border: '1px solid #fbbf24',
            borderRadius: '8px',
            fontSize: '12px',
            color: '#92400e',
            marginTop: '12px'
          }}>
            ⚠️ 無料プランに変更する場合は、現在のプランを解約してください。解約すると自動的に無料プランになります。
          </div>
        </button>
<button
  onClick={async () => {
    const targetUserId = currentUser.role === 'parent' ? currentUser.id : currentUser.linked_user_id;
    const targetPlan = currentUser.role === 'parent' ? currentUser.plan : parentData?.plan;
    
    if (targetPlan === 'basic') return;
    
    // ✅ 既にサブスクリプションがある場合はプラン変更
    if (currentUser.stripe_subscription_id || parentData?.stripe_subscription_id) {
      if (!window.confirm('ベーシックプランに変更しますか？\n\n※既に支払った分の返金はありません。')) {
        return;
      }
      
      try {
        const response = await fetch('/api/change-plan', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            userId: targetUserId,
            newPlan: 'basic'
          })
        });
        
        const data = await response.json();
        
        if (data.success) {
          alert('ベーシックプランに変更しました!');
          window.location.reload();
        } else {
          alert('プラン変更に失敗しました: ' + (data.error || '不明なエラー'));
        }
      } catch (error) {
        console.error('Plan Change Error:', error);
        alert('プラン変更に失敗しました');
      }
    } else {
      // ✅ サブスクリプションがない場合は新規登録
      try {
        const response = await fetch('/api/create-checkout', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            userId: targetUserId,
            plan: 'basic'
          })
        });
        
        const data = await response.json();
        if (data.url) {
          window.location.href = data.url;
        } else {
          alert('エラーが発生しました: ' + (data.error || '不明なエラー'));
        }
      } catch (error) {
        console.error('Checkout Error:', error);
        alert('決済ページへの移動に失敗しました');
      }
    }
  }}
          disabled={currentUser.role === 'parent' ? currentUser.plan === 'basic' : parentData?.plan === 'basic'}
          style={{
            padding: '16px',
            background: currentUser.plan === 'basic' ? '#e2e8f0' : '#10b981',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: currentUser.plan === 'basic' ? 'not-allowed' : 'pointer',
            textAlign: 'left'
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px' }}>
            ベーシックプラン - 月額490円
          </div>
          <div style={{ fontSize: '14px' }}>
            • 1日7回まで利用可能<br />
            • 5種類の話し方から選択
          </div>
        </button>

        {/* バリュープラン */}
       <button
  onClick={async () => {
    const targetUserId = currentUser.role === 'parent' ? currentUser.id : currentUser.linked_user_id;
    const targetPlan = currentUser.role === 'parent' ? currentUser.plan : parentData?.plan;
    
   // ✅ デバッグ用
  console.log('=== バリュープラン変更開始 ===');
  console.log('currentUser:', currentUser);
  console.log('targetUserId:', targetUserId);
  console.log('targetPlan:', targetPlan);
  console.log('stripe_subscription_id:', currentUser.stripe_subscription_id);

    if (targetPlan === 'value') return;
    
    // ✅ 既にサブスクリプションがある場合はプラン変更
    if (currentUser.stripe_subscription_id || parentData?.stripe_subscription_id) {
       console.log('✅ プラン変更ルートに入ります');
      if (!window.confirm('バリュープランに変更しますか？\n\n※既に支払った分の返金はありません。')) {
        return;
      }
      
      try {
        console.log('API呼び出し開始...');
        const response = await fetch('/api/change-plan', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            userId: targetUserId,
            newPlan: 'value'
          })
        });
        console.log('レスポンスステータス:', response.status);

        const data = await response.json();
        console.log('レスポンスデータ:', data);

        if (data.success) {
          alert('バリュープランに変更しました!');
          window.location.reload();
        } else {
          console.error('エラー:', data.error);
          alert('プラン変更に失敗しました: ' + (data.error || '不明なエラー'));
        }
      } catch (error) {
        console.error('Plan Change Error:', error);
        alert('プラン変更に失敗しました');
      }
    } else {
      console.log('❌ 新規登録ルートに入ります');
      // ✅ サブスクリプションがない場合は新規登録
      try {
        const response = await fetch('/api/create-checkout', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ 
            userId: targetUserId,
            plan: 'value'
          })
        });
        
        const data = await response.json();
        if (data.url) {
          window.location.href = data.url;
        } else {
          alert('エラーが発生しました: ' + (data.error || '不明なエラー'));
        }
      } catch (error) {
        console.error('Checkout Error:', error);
        alert('決済ページへの移動に失敗しました');
      }
    }
  }}
          disabled={currentUser.role === 'parent' ? currentUser.plan === 'value' : parentData?.plan === 'value'}
          style={{
            padding: '16px',
            background: currentUser.plan === 'value' ? '#e2e8f0' : '#8b5cf6',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: currentUser.plan === 'value' ? 'not-allowed' : 'pointer',
            textAlign: 'left'
          }}
        >
          <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px' }}>
            バリュープラン - 月額980円
          </div>
          <div style={{ fontSize: '14px' }}>
            • 1日15回まで利用可能<br />
            • 5種類の話し方から選択
          </div>
        </button>
      </div>

      <button 
        className="close-button" 
        onClick={() => setShowPlanChange(false)}
        style={{ marginTop: '16px' }}
      >
        閉じる
      </button>
    </div>
  </div>
)}
      <div className="container">
     {currentUser && (
    <div style={{ marginBottom: 16 }}>
      <div style={{ 
        fontSize: 14, 
        color: '#555',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 8
      }}>
        <span>ログイン中：{currentUser.name}（{currentUser.role === 'parent' ? 'メイン' : 'サポート'}）</span>
        <button 
          onClick={handleLogout}
          style={{
            padding: '6px 12px',
            fontSize: '12px',
            background: '#ef4444',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer'
          }}
        >
          ログアウト
        </button>
      </div>
      
   {/* ✅ 招待コード表示（メインユーザーのみ） */}
{currentUser.role === 'parent' && currentUser.invite_code && (
  <div style={{
    background: '#eff6ff',
    border: '2px solid #3b82f6',
    borderRadius: '8px',
    padding: '12px',
    fontSize: '14px',
    color: '#1e40af',
    textAlign: 'center'
  }}>
    <span style={{ fontWeight: 'normal' }}>あなたの招待コードは </span>
    <span style={{ 
      fontSize: '24px', 
      fontWeight: 'bold',
      letterSpacing: '4px',
      margin: '0 8px'
    }}>
      {currentUser.invite_code}
    </span>
    <span style={{ fontWeight: 'normal' }}> です</span>
  
  <div style={{ fontSize: '12px', color: '#1e40af', marginTop: '8px' }}>
      ※ ログインする際に必要となることがあります。メモしておいてください。
    </div>
    </div>
)}
{/* ✅ 招待履歴・プラン変更ボタン（メインユーザーのみ） */}
{/* ✅ 招待履歴・プラン変更ボタン */}
{activeTab === 'home' && (
  <div style={{ 
    marginTop: '12px', 
    display: 'flex', 
    gap: '8px', 
    justifyContent: 'center' 
  }}>
    {/* ✅ 招待履歴はメインのみ */}
    {currentUser.role === 'parent' && (
      <button
        onClick={() => {
          fetchInvitedUsers();
          setShowInviteHistory(true);
        }}
        style={{
          padding: '8px 16px',
          background: '#10b981',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '14px',
          flex: 1,
          maxWidth: '180px'
        }}
      >
        招待履歴を見る
      </button>
    )}
    
    {/* ✅ プラン変更は全員 */}
    <button
      onClick={() => setShowPlanChange(true)}
      style={{
        padding: '8px 16px',
        background: '#f59e0b',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        fontSize: '14px',
        flex: 1,
        maxWidth: currentUser.role === 'parent' ? '180px' : '100%'
      }}
    >
      プランを変更
    </button>
  </div>
)}
   </div>
)}   
        {/* ヘッダー部分（ホームタブのみ表示） */}
{activeTab === 'home' && (
  <div className="header">
          {/* 画像を表示するための構造。CSSが正しく適用されていれば表示されます。 */}
          <div className="header-main-layout">
            
            {/* 左側：挨拶、時刻、サマリー */}
            <div className="header-info-summary">
              <div className="header-content">
                <div className="header-left">
  
  <div>
    
   <p className="date" style={{ 
    background: '#ef4444', 
    color: 'white', 
    padding: '4px 12px', 
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: 'bold',
    display: 'inline-block',
    marginBottom: '4px'
  }}>
    無料お試しキャンペーン中
  </p>
  <p className="date" style={{ fontSize: '14px', marginTop: '4px' }}>
    {currentTime.toLocaleDateString('ja-JP')}
  </p>
  <h1 style={{ whiteSpace: 'nowrap', fontSize: '20px' }}>見守りAIアプリ</h1>
</div>

 {/* ✅ SOERU ロゴ追加 */}
              <img 
                src={process.env.PUBLIC_URL + "/logo.png"} 
                alt="SOERU ロゴ"
                className="soeru-logo"
              />
              
</div>


                <div className="header-right">
                  <div className="time">
                    {currentTime.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' })}
                  </div>
                </div>
              </div>
<div className="summary">
                <p className="greeting">{getGreeting()}</p>
                  {/* ✅ サポーター（child）の場合の注意書き */}
  {currentUser?.role === 'child' && (
    <div style={{
      marginTop: '12px',
      padding: '12px',
      background: '#fef3c7',
      border: '2px solid #fbbf24',
      borderRadius: '8px',
      fontSize: '12px',
      color: '#92400e',
      lineHeight: '1.6'
    }}>
      <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', fontSize: '13px' }}>
        ⚠️ サポート（見守る側）画面について
      </p>
      <ul style={{ margin: 0, paddingLeft: '23px' }}>
    
        <li>メイン利用者の利用回数から減りますので、履歴参照等以外のサービスは控えることを推奨します</li>
      </ul>
    </div>
  )}
                {/* ✅ 親（メイン使用者）の場合のみ表示 */}
                {currentUser?.role === 'parent' && (
                 <div className="summary-grid" style={{
  display: 'grid',
  gridTemplateColumns: '1fr 1fr 1fr',
  gap: '8px',
  fontSize: '16px'
}}>
  <div className="summary-item" style={{ 
    display: 'flex', 
    flexDirection: 'column',  // ✅ 縦並び
    alignItems: 'center',
    gap: '4px'
  }}>
    <span style={{ fontSize: '16px', color: '#64748b' }}>体調</span>
    <span className="summary-value" style={{ fontSize: '15px', fontWeight: 'bold' }}>
      {summary.safetyCheck}
    </span>
  </div>
  <div className="summary-item" style={{ 
    display: 'flex', 
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px'
  }}>
    <span style={{ fontSize: '16px', color: '#64748b' }}>服薬</span>
    <span className="summary-value" style={{ fontSize: '15px', fontWeight: 'bold' }}>
      {summary.medications}
    </span>
  </div>
  <div className="summary-item" style={{ 
    display: 'flex', 
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px'
  }}>
    <span style={{ fontSize: '14px', color: '#64748b' }}>利用回数</span>
    <span className="summary-value" style={{ 
      color: remainingUses && remainingUses.startsWith('0') ? '#ef4444' : '#10b981',
      fontWeight: 'bold',
      fontSize: '15px'
    }}>
      残 {remainingUses || '...'}回
    </span>
  </div>
</div>
                )}
              </div>
            </div>
            
            {/* 右側：介護士の画像とチェックマーク */}
            <div className="nurse-image-container">
              <img 
                src={process.env.PUBLIC_URL + "/nurse.jpg"} 
                alt="看護師"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                  borderRadius: '50%'
                }}
              />
              <div className="check-mark-overlay">
                <CheckCircle className="check-icon" size={40} />
              </div>
            </div>
            </div>
            
          </div>
        
        )} 
        {/* ← これを追加（ヘッダーの条件終了） */}

{/* ✅ child専用：親の今日の状況 */}
        {currentUser?.role === 'child' && parentData && (
          <div
            style={{
              background: '#f8fafc',
              border: '2px solid #6366f1',
              borderRadius: 12,
              padding: 16,
              margin: '0 16px 16px 16px'
            }}
          >
            <h3 style={{ 
              marginBottom: 12, 
              fontSize: '16px', 
              fontWeight: 'bold',
              textAlign: 'center'
            }}>
              親の今日の状況
            </h3>
<p style={{ 
  fontSize: '12px', 
  color: '#64748b', 
  textAlign: 'center',
  marginBottom: 12,
  lineHeight: '1.6'
}}>
  画面下部の履歴より、最近の状況をご確認いただけます
</p>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr 1fr',
              gap: '12px'
            }}>
              <div style={{
                background: 'white',
                padding: '12px',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '24px', marginBottom: '4px' }}>👤</div>
                <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px' }}>親の名前</div>
                <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{parentData.name}</div>
              </div>

              <div style={{
                background: 'white',
                padding: '12px',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '24px', marginBottom: '4px' }}>❤️</div>
                <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px' }}>体調</div>
                <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{getParentSummary().condition}</div>
              </div>

              <div style={{
                background: 'white',
                padding: '12px',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                <div style={{ fontSize: '24px', marginBottom: '4px' }}>💊</div>
                <div style={{ fontSize: '11px', color: '#64748b', marginBottom: '4px' }}>服薬</div>
                <div style={{ fontSize: '14px', fontWeight: 'bold' }}>{getParentSummary().medication}</div>
              </div>
            </div>
          </div>
        )} 


        {isLoading && (
          <div className="loading-banner">
            <div className="loading-spinner"></div>
            <p>考え中...少々お待ちください...</p>
          </div>
        )}

        {/* 連続対話中であることを示すインジケータ */}
        {isListening && continueConversation && (
            <div className="listening-indicator">
              <Mic size={20} className="mic-icon-listening" />
              <p>対話継続中...お話しください</p>
            </div>
        )}
{activeTab === 'home' && (
      <div className="claude-card">
  <div className="claude-header">
    <MessageCircle size={32} />
    <h2>ソエルとお話し</h2>
  </div>
 <div
  className="claude-buttons"
  style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '12px' }}
>
  {/* 🎤 マイクで話しかけるボタン */}
  <button
  onClick={() => {
    unlockIOSAudio();
    startListening(false);
  }}
  className="claude-button mic-button"
  disabled={isLoading || isListening}
  style={{ 
    fontSize: '13px', 
    padding: '12px 8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '4px'
  }}
>
    <Mic size={20} />
    <span style={{ fontWeight: 'bold' }}>
      {isListening ? '聞いています...' : '話しかける'}
    </span>
    {!isListening && (
      <span style={{ fontSize: '10px', opacity: 0.8, textAlign: 'center', lineHeight: '1.3' }}>
        マイクボタンを押して<br />話しかけてください
      </span>
 )}
  
  {/* ✅ マイク音量バー追加 */}
  {isListening && (
    <div style={{
      width: '100%',
      height: '6px',
      background: '#e2e8f0',
      borderRadius: '3px',
      overflow: 'hidden',
      marginTop: '8px'
    }}>
      <div style={{
        width: `${micLevel}%`,
        height: '100%',
        background: micLevel > 50 ? '#10b981' : '#3b82f6',
        transition: 'width 0.1s ease'
      }}></div>
    </div>
  )}
</button>

  {/* ⌨ 文字で質問ボタン（音声認識は起動しない） */}
  <button
    onClick={() => {
      unlockIOSAudio();               // iPhone向けの事前再生（将来の音声読み上げ用）
      setShowTextInput((prev) => !prev);
    }}
    className="claude-button text-button"
    disabled={isLoading}
    style={{ fontSize: '14px', padding: '12px 8px' }}
  >
    <Keyboard size={20} />
    <span>文字で質問</span>
  </button>

  {/* 💬 今日の情報ボタン（音声認識は起動しない） */}
 {/* 💬 今日の情報ボタン（音声認識は起動しない） */}
  <button
  onClick={async () => {
    unlockIOSAudio();
    stopConversation();

    await openClaudeChat();
  }}
  className="claude-button info-button" 
  disabled={isLoading}
  style={{ fontSize: '14px', padding: '12px 8px' }}
>
  <MessageCircle size={20} />
  <span>今日の情報</span>
</button>


  {/* ⏹ 停止ボタン（ここは今まで通り） */}
  <button
    onClick={stopConversation}
    className="claude-button"
    disabled={!isListening && !showMessage && !isLoading}
    style={{
      fontSize: '14px',
      padding: '12px 8px',
      background: (isListening || showMessage || isLoading) ? '#ef4444' : '#94a3b8',
      opacity: (!isListening && !showMessage && !isLoading) ? 0.5 : 1,
      cursor: (!isListening && !showMessage && !isLoading) ? 'not-allowed' : 'pointer',
    }}
  >
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="6" y="6" width="12" height="12" />
    </svg>
    <span>停止</span>
  </button>
</div>

          
          {showTextInput && (
            <div className="text-input-area">
              <input
                type="text"
                value={textInput}
                onChange={(e) => setTextInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleTextInput()}
                placeholder="質問を入力してください..."
                className="text-input"
                disabled={isLoading}
              />
              <button 
                onClick={handleTextInput}
                className="send-button"
                disabled={isLoading || !textInput.trim()}
              >
                送信
              </button>
            </div>
          )}
        </div>
        )}  {/* ← ソエルとお話しの条件終了 */}
<div className="content">
  {/* ✅ ホームタブのみ表示 */}
  {activeTab === 'home' && (
    <>
      {/* ✅ なぞなぞチャレンジ */}
      <div className="section" style={{ marginBottom: '20px' }}>
        <button
          onClick={startRiddle}
          disabled={isLoading}
          style={{
            width: '100%',
            padding: '20px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            fontSize: '20px',
            fontWeight: 'bold',
            boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px'
          }}
        >
          🧩 1日1回なぞなぞチャレンジ（頭の体操）
        </button>
      </div>

      {/* ✅ キャラ選択 */}
      <div className="section">
        <h3 className="subsection-title">話し方を選んでください</h3>
        
        <p style={{
          fontSize: '16px',
          color: '#64748b',
          textAlign: 'center',
          margin: '8px 0 16px 0',
          lineHeight: '1.5'
        }}>
          🔊 音量が小さいと聞こえにくい場合があります。音量を上げてお楽しみください。
        </p>

        {currentUser?.plan === 'free' ? (
          <div style={{ 
            background: '#f8fafc', 
            border: '2px solid #e2e8f0', 
            borderRadius: '12px', 
            padding: '16px',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '32px', marginBottom: '8px' }}>
              {CHARACTER_PROMPTS.woman30.emoji}
            </div>
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
              {CHARACTER_PROMPTS.woman30.label}
            </div>
            <p style={{ fontSize: '14px', color: '#64748b', marginTop: '8px' }}>
              無料お試しプラン：看護師風の話し方のみ（1日3回まで）
            </p>
          </div>
        ) : (
          <>
            <div className="button-grid">
              {Object.entries(CHARACTER_PROMPTS).map(([id, char]) => (
                <button
                  key={id}
                  onClick={() => setSelectedCharacter(id)}
                  className={`character-button ${selectedCharacter === id ? 'active' : ''}`}
                >
                  <img 
                    src={`${process.env.PUBLIC_URL}/characters/${id}.jpg`}
                    alt={char.label}
                    className="character-avatar"
                  />
                  <div className="character-check">✓</div>
                  <div className="character-label">{char.label}</div>
                </button>
              ))}
            </div>
            <p className="hint">
              Basicプラン：5種類の話し方から選択可能（1日10回まで）
            </p>
          </>
        )}
      </div>

      {/* ✅ かんたん記録 */}
      <h2 className="section-title">かんたん記録</h2>
      
      <div className="section">
        <h3 className="subsection-title">
          <Heart className="icon-red" size={24} />
          今日の体調はどうですか?
        </h3>
        <div className="button-grid">
          <button
            className="status-button good"
            disabled={isLoading}
            onClick={() => addSafetyCheck('良好')}
          >
            良好
          </button>

          <button
            className="status-button normal"
            disabled={isLoading}
            onClick={() => addSafetyCheck('普通')}
          >
            普通
          </button>

          <button
            className="status-button caution"
            disabled={isLoading}
            onClick={() => addSafetyCheck('注意')}
          >
            注意
          </button>
        </div>
        <p className="hint">ボタンを押すと自動で話します</p>
      </div>

      <div className="section">
        <h3 className="subsection-title">
          <Pill className="icon-blue" size={24} />
          お薬を飲みましたか?
        </h3>
        <div className="med-list">
          {medications.map(med => (
            <button
              key={med.id}
              onClick={() => toggleMedication(med.id)}
              className={`med-item ${med.taken ? 'taken' : ''}`}
              disabled={isLoading || med.taken}
            >
              <div className="med-left">
                <div className={`checkbox ${med.taken ? 'checked' : ''}`}>
                  {med.taken && '✓'}
                </div>
                <div>
                  <h4>{med.name}</h4>
                  <p>{med.time}</p>
                </div>
              </div>
              {med.taken && <span className="badge">済</span>}
            </button>
          ))}
        </div>
          <p className="hint">チェックすると自動で情報を話します</p>
      </div>
      
      {/* ✅ ホーム画面に追加の案内（activeTab が home の時のみ表示） */}
      {activeTab === 'home' && (
        <div style={{
          marginTop: '32px',
          padding: '20px',
          background: '#eff6ff',
          border: '2px solid #3b82f6',
          borderRadius: '12px'
        }}>
          <h3 style={{ 
            fontSize: '16px', 
            fontWeight: 'bold', 
            marginBottom: '12px',
            color: '#1e40af',
            textAlign: 'center'
          }}>
            📱 アプリのように使うには
          </h3>
          <img 
            src={process.env.PUBLIC_URL + "/Gemini_Generated_Image_4aappy4aappy4aap.png"}
            alt="ホーム画面に追加"
            style={{ 
             width: '100%',
  display: 'block',
  borderRadius: '8px'
            }}
          />
        </div>
      )}
    </>
  )}

  {activeTab === 'history' && (
    <div>
      <button 
        onClick={() => setActiveTab('home')}
        style={{
          width: '100%',
          padding: '12px',
          marginBottom: '20px',
          background: '#10b981',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '18px',
          fontWeight: 'bold'
        }}
      >
        ← ホームに戻る
      </button>
              
      <h3 className="subsection-title">体調の記録</h3>
      <div className="history-list">
        {safetyCheckHistory.map((check, index) => (
          <div key={index} className="history-item">
            <span className={`status-badge ${check.status}`}>
              {check.status}
            </span>
            <span className="date-small">
              {new Date(check.created_at).toLocaleString('ja-JP', {
                month: 'numeric',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </span>
          </div>
        ))}
        {safetyCheckHistory.length === 0 && (
          <p className="empty">まだ記録がありません</p>
        )}
      </div>

      <h3 className="subsection-title" style={{ marginTop: '24px' }}>服薬の記録</h3>
      <div className="history-list">
        {medicationHistory.map((med, index) => (
          <div key={index} className="history-item">
            <span className="status-badge good">
              {med.name}
            </span>
            <span className="date-small">
              {new Date(med.taken_at).toLocaleString('ja-JP', {
                month: 'numeric',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </span>
          </div>
        ))}
        {medicationHistory.length === 0 && (
          <p className="empty">まだ記録がありません</p>
        )}
      </div>
    </div>
  )}
</div>

{/* ✅ 免責事項 */}
      <div style={{
        padding: '12px 16px',
        background: '#f8fafc',
        borderTop: '1px solid #e2e8f0',
        textAlign: 'center',
        fontSize: '11px',
        color: '#64748b',
        lineHeight: '1.4'
      }}>
        <p style={{ margin: 0 }}>
          ⚠️ AIは誤りを含む可能性があります。医療行為や緊急時の判断には使用しないでください。
        </p>
      </div>

   <div className="bottom-nav">
  <button
    onClick={() => setActiveTab('home')}
    className={`nav-button ${activeTab === 'home' ? 'active' : ''}`}
  >
    <Heart size={28} />
    <span>ホーム</span>
  </button>
  
  <button
    onClick={async () => {
      setActiveTab('history');
      if (currentUser.role === 'child' && currentUser.linked_user_id) {
        const safetyHistory = await fetchSafetyCheckHistory(currentUser.linked_user_id);
        setSafetyCheckHistory(safetyHistory);
        const medHistory = await fetchMedicationHistory(currentUser.linked_user_id);
        setMedicationHistory(medHistory);
      } else {
        const safetyHistory = await fetchSafetyCheckHistory(currentUser.id);
        setSafetyCheckHistory(safetyHistory);
        const medHistory = await fetchMedicationHistory(currentUser.id);
        setMedicationHistory(medHistory);
      }
    }}
    className={`nav-button ${activeTab === 'history' ? 'active' : ''}`}
  >
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
    <span>履歴</span>
  </button>
  
  <button
    onClick={() => {
      setActiveTab('contacts');
      setShowEmergencyForm(true);
    }}
    className={`nav-button ${activeTab === 'contacts' ? 'active' : ''}`}
  >
    <Phone size={22} />
    <span>連絡先<br />登録<br />情報</span>
  </button>
  
  <button
    onClick={() => {
      window.open('https://forms.gle/u6wYTeq8H4qe3gh29', '_blank');
    }}
    className="nav-button"
  >
    <MessageCircle size={24} />
    <span>お問い合わせ</span>
  </button>
  
  {/* ✅ 利用規約ボタン */}
  <button
    onClick={() => {
      setShowTerms(true);
    }}
    className="nav-button"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
      <polyline points="14 2 14 8 20 8"></polyline>
      <line x1="16" y1="13" x2="8" y2="13"></line>
      <line x1="16" y1="17" x2="8" y2="17"></line>
      <polyline points="10 9 9 9 8 9"></polyline>
    </svg>
    <span>利用<br />規約</span>
  </button>
  
  {/* ✅ 特定商取引法ボタン */}
  <button
    onClick={() => {
      setShowTokuho(true);
    }}
    className="nav-button"
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="9" y1="9" x2="15" y2="9"></line>
      <line x1="9" y1="13" x2="15" y2="13"></line>
      <line x1="9" y1="17" x2="15" y2="17"></line>
    </svg>
    <span>特定商<br />取引法</span>
  </button>
</div>

      {/* 連絡先・登録情報モーダル */}
{showEmergencyForm && (
  <div className="modal-overlay" onClick={() => setShowEmergencyForm(false)}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      {/* ホームに戻るボタン */}
      <button 
        onClick={() => {
          setShowEmergencyForm(false);
          setActiveTab('home');
        }}
        style={{
          width: '100%',
          padding: '12px',
          marginBottom: '12px',
          background: '#10b981',
          color: 'white',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '18px',
          fontWeight: 'bold'
        }}
      >
        ← ホームに戻る
      </button>


      {/* タブ切り替え */}
      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e2e8f0' }}>
        <button
          onClick={() => setEmergencyTab('contacts')}
          style={{
            flex: 1,
            padding: '12px',
            background: emergencyTab === 'contacts' ? '#3b82f6' : 'transparent',
            color: emergencyTab === 'contacts' ? 'white' : '#64748b',
            border: 'none',
            borderBottom: emergencyTab === 'contacts' ? '3px solid #3b82f6' : 'none',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: emergencyTab === 'contacts' ? 'bold' : 'normal'
          }}
        >
          📞 連絡先
        </button>
        <button
          onClick={() => setEmergencyTab('info')}
          style={{
            flex: 1,
            padding: '12px',
            background: emergencyTab === 'info' ? '#3b82f6' : 'transparent',
            color: emergencyTab === 'info' ? 'white' : '#64748b',
            border: 'none',
            borderBottom: emergencyTab === 'info' ? '3px solid #3b82f6' : 'none',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: emergencyTab === 'info' ? 'bold' : 'normal'
          }}
        >
          📝 登録情報
        </button>
      </div>

      {/* 連絡先タブ */}
{emergencyTab === 'contacts' && (
  <>
    <h2>緊急連絡先</h2>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
      {emergencyContacts.map((contact, index) => (
        <div key={index} style={{ 
          padding: '15px', 
          background: '#f8fafc', 
          borderRadius: '8px',
          border: '1px solid #e2e8f0'
        }}>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '14px', color: '#64748b' }}>名前</label>
            <input
              type="text"
              value={contact.name || ''}
              onChange={(e) => {
                const newContacts = [...emergencyContacts];
                newContacts[index].name = e.target.value;
                setEmergencyContacts(newContacts);
              }}
              placeholder="山田 太郎"
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                marginTop: '4px'
              }}
            />
          </div>
          <div style={{ marginBottom: '10px' }}>
            <label style={{ fontSize: '14px', color: '#64748b' }}>続柄</label>
            <input
              type="text"
              value={contact.relation || ''}
              onChange={(e) => {
                const newContacts = [...emergencyContacts];
                newContacts[index].relation = e.target.value;
                setEmergencyContacts(newContacts);
              }}
              placeholder="息子"
              style={{
                width: '100%',
                padding: '8px',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                marginTop: '4px'
              }}
            />
          </div>
          <div>
            <label style={{ fontSize: '14px', color: '#64748b' }}>電話番号</label>
            <input
  type="tel"
  value={contact.phone || ''}
  onChange={(e) => {
    let value = e.target.value;
    
    // ✅ 全角数字を半角に変換
    value = value.replace(/[０-９]/g, (s) => {
      return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
    });
    
    // ✅ 全角ハイフンを半角に変換
    value = value.replace(/ー/g, '-');
    
    const newContacts = [...emergencyContacts];
    newContacts[index].phone = value;
    setEmergencyContacts(newContacts);
  }}
  placeholder="090-1234-5678"
  style={{
    width: '100%',
    padding: '8px',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    marginTop: '4px'
  }}
/>
          </div>
          <button
            onClick={() => {
              const newContacts = emergencyContacts.filter((_, i) => i !== index);
              setEmergencyContacts(newContacts);
            }}
            style={{
              marginTop: '10px',
              padding: '6px 12px',
              background: '#ef4444',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '12px'
            }}
          >
            削除
          </button>
        </div>
      ))}
      
      <button
        onClick={() => setEmergencyContacts([...emergencyContacts, { name: '', relation: '', phone: '' }])}
        style={{
          padding: '12px',
          background: '#f1f5f9',
          border: '2px dashed #cbd5e1',
          borderRadius: '8px',
          cursor: 'pointer',
          color: '#64748b'
        }}
      >
        ＋ 連絡先を追加
      </button>
    </div>
    <button onClick={saveEmergencyContacts} className="status-button good" style={{ marginTop: '20px', width: '100%' }}>
      保存
    </button>
  </>
)}

      {/* 登録情報タブ */}
      {emergencyTab === 'info' && (
        <>
          <h2>登録情報</h2>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            <div style={{
              padding: '15px',
              background: '#f8fafc',
              borderRadius: '8px',
              border: '1px solid #e2e8f0'
            }}>
              <label style={{ fontSize: '14px', color: '#64748b', display: 'block', marginBottom: '8px' }}>お名前</label>
              <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{currentUser?.name || '未設定'}</div>
            </div>

            <div style={{
              padding: '15px',
              background: '#f8fafc',
              borderRadius: '8px',
              border: '1px solid #e2e8f0'
            }}>
              <label style={{ fontSize: '14px', color: '#64748b', display: 'block', marginBottom: '8px' }}>プラン</label>
              <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                {currentUser?.plan === 'basic' ? '✨ Basicプラン' : '🆓 無料プラン'}
              </div>
            </div>

            <div style={{
              padding: '15px',
              background: '#f8fafc',
              borderRadius: '8px',
              border: '1px solid #e2e8f0'
            }}>
              <label style={{ fontSize: '14px', color: '#64748b', display: 'block', marginBottom: '8px' }}>
                郵便番号
              </label>
            <input
  type="tel"
  inputMode="numeric"
  value={postalCode}
  onChange={handlePostalCodeChange}
  placeholder="857-0001"
  maxLength="8"
  style={{
    width: '100%',
    padding: '8px',
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    fontSize: '16px'
  }}
/>
              <p style={{ fontSize: '12px', color: '#64748b', marginTop: '4px' }}>
                ※イベント情報・会話等に使用します
              </p>
            </div>

            {(prefecture || city) && (
              <div style={{
                padding: '12px',
                background: '#f0f9ff',
                border: '1px solid #bae6fd',
                borderRadius: '8px',
                fontSize: '14px',
                color: '#0369a1'
              }}>
                📍 {prefecture} {city}
              </div>
            )}

            <button
              onClick={async () => {
                const { error } = await supabase
                  .from('users')
                  .update({
                    postal_code: postalCode || null,
                    prefecture: prefecture || null,
                    city: city || null
                  })
                  .eq('id', currentUser.id);

                if (error) {
                  alert('保存に失敗しました');
                } else {
                  alert('登録情報を更新しました');
                  setCurrentUser({ ...currentUser, postal_code: postalCode, prefecture, city });
                }
              }}
              className="status-button good"
              style={{ width: '100%' }}
            >
              保存
            </button>
          </div>
        </>
      )}
    </div>
  </div>
)}
  {/* なぞなぞモーダル */}
{showRiddle && riddleData && (
  <div className="message-overlay" onClick={() => setShowRiddle(false)}>
    <div className="message-box" onClick={(e) => e.stopPropagation()}>
      <div className="message-header">
        <img 
          src={`${process.env.PUBLIC_URL}/characters/${selectedCharacter}.jpg`}
          alt={CHARACTER_PROMPTS[selectedCharacter]?.label}
          className="message-avatar"
        />
        <h3>🧩 なぞなぞチャレンジ</h3>
      </div>
      
      <div style={{ 
        padding: '20px', 
        background: '#f8fafc', 
        borderRadius: '12px',
        marginBottom: '20px'
      }}>
        <p style={{ 
          fontSize: '18px', 
          lineHeight: '1.8',
          marginBottom: '20px',
          fontWeight: 'bold'
        }}>
          {riddleData.question}
        </p>
        {!showAnswer ? (
  <button
    onClick={revealAnswer}
    style={{
      width: '100%',
      padding: '16px',
      background: '#f59e0b',
      color: 'white',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      fontSize: '18px',
      fontWeight: 'bold',
      marginTop: '10px'
    }}
  >
    💡 答えを聞く
  </button>
) : (
  <div style={{ 
    padding: '16px', 
    background: '#dcfce7',
    border: '2px solid #16a34a',
    borderRadius: '8px',
    marginTop: '20px'
  }}>
    <p style={{ 
  fontSize: '18px',  // ← 大きく
  color: '#166534',
  fontWeight: 'bold',
  textAlign: 'center',
  lineHeight: '1.6'  // ← 行間追加
}}>
  {riddleData.answerText || '答えを聞いてください！'}
</p>
  </div>
)}
      </div>
      
      <button 
        className="close-button" 
        onClick={() => {
          setShowRiddle(false);
          stopConversation();
        }}
      >
        閉じる
      </button>
    </div>
  </div>
)}
{/* 利用規約モーダル */}
{showTerms && (
  <div className="message-overlay" onClick={() => setShowTerms(false)}>
    <div className="message-box" onClick={(e) => e.stopPropagation()} style={{ maxHeight: '80vh', overflowY: 'auto' }}>
      <h2 style={{ marginBottom: '20px' }}>利用規約</h2>
      
      <div style={{ textAlign: 'left', fontSize: '14px', lineHeight: '1.8' }}>
        <h3>第1条（適用）</h3>
        <p>本規約は、本サービスの利用に関する条件を定めるものです。ユーザーは本規約に同意の上、本サービスを利用するものとします。</p>
        
        <h3>第2条（利用登録）</h3>
        <p>本サービスの利用を希望する方は、本規約に同意の上、登録を行うものとします。</p>
        
        <h3>第3条（禁止事項）</h3>
        <p>ユーザーは、本サービスの利用にあたり、以下の行為をしてはなりません。</p>
        <ul>
          <li>法令または公序良俗に違反する行為</li>
          <li>犯罪行為に関連する行為</li>
          <li>本サービスの運営を妨害する行為</li>
          <li>他のユーザーに迷惑をかける行為</li>
        </ul>
        
        <h3>第4条（免責事項）</h3>
        <p>本サービスは、AIによる応答を含むため、誤った情報が提供される可能性があります。医療行為や緊急時の判断には使用しないでください。運営者は、本サービスの利用により生じた損害について、一切の責任を負いません。</p>
        
        <h3>第5条（個人情報の取扱い）</h3>
        <p>個人情報の取扱いについては、別途定めるプライバシーポリシーに従います。</p>
        
        <h3>第6条（サービスの変更・終了）</h3>
        <p>運営者は、ユーザーへの事前の通知なく、本サービスの内容を変更、または提供を終了することができます。</p>
        
        <h3>第7条（準拠法・管轄裁判所）</h3>
        <p>本規約の解釈にあたっては、日本法を準拠法とします。本サービスに関する紛争については、運営者の所在地を管轄する裁判所を専属的合意管轄とします。</p>
        
        <hr style={{ margin: '30px 0', border: 'none', borderTop: '2px solid #e5e7eb' }} />
        
        <h2 style={{ marginTop: '30px', marginBottom: '20px' }}>プライバシーポリシー</h2>
        
        <h3>1. 収集する情報</h3>
        <p>本サービスでは、以下の情報を収集します。</p>
        <ul>
          <li>お名前</li>
          <li>郵便番号、都道府県、市区町村</li>
          <li>体調記録、服薬記録</li>
          <li>決済情報（Stripe経由、当社は保存しません）</li>
        </ul>
        
        <h3>2. 利用目的</h3>
        <ul>
          <li>サービスの提供</li>
          <li>健康状態の記録・管理</li>
          <li>決済処理</li>
          <li>サービス改善のための分析</li>
        </ul>
        
        <h3>3. 第三者提供</h3>
        <p>本サービスは以下の外部サービスを利用しています。</p>
        <ul>
          <li>Supabase（データベース）- アメリカ</li>
          <li>Stripe（決済）- アメリカ</li>
          <li>OpenAI（AI音声生成）- アメリカ</li>
          <li>Anthropic（AI会話）- アメリカ</li>
        </ul>
        
        <h3>4. データの保存期間</h3>
        <p>ユーザーがアカウントを削除するまで保存されます。</p>
        
        <h3>5. お問い合わせ</h3>
        <p>個人情報に関するお問い合わせは、以下までご連絡ください。</p>
        <p>メール: leefria1119@hotmail.com</p>
        
        <hr style={{ margin: '30px 0', border: 'none', borderTop: '2px solid #e5e7eb' }} />
        
        <h2 style={{ marginTop: '30px', marginBottom: '20px' }}>特定商取引法に基づく表記</h2>
        
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
              <td style={{ padding: '12px', fontWeight: 'bold', width: '30%' }}>事業者名</td>
              <td style={{ padding: '12px' }}>冨岡 泰裕</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
              <td style={{ padding: '12px', fontWeight: 'bold' }}>所在地</td>
              <td style={{ padding: '12px' }}>長崎県佐世保市</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
              <td style={{ padding: '12px', fontWeight: 'bold' }}>連絡先</td>
              <td style={{ padding: '12px' }}>tomioka.yasuhiro@example.com</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
              <td style={{ padding: '12px', fontWeight: 'bold' }}>販売価格</td>
              <td style={{ padding: '12px' }}>
                ベーシックプラン: 490円/月（税込）<br />
                バリュープラン: 980円/月（税込）
              </td>
            </tr>
            <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
              <td style={{ padding: '12px', fontWeight: 'bold' }}>支払方法</td>
              <td style={{ padding: '12px' }}>クレジットカード（Stripe）</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
              <td style={{ padding: '12px', fontWeight: 'bold' }}>支払時期</td>
              <td style={{ padding: '12px' }}>登録時即時決済、以降毎月自動更新</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
              <td style={{ padding: '12px', fontWeight: 'bold' }}>サービス提供時期</td>
              <td style={{ padding: '12px' }}>決済完了後、即時利用可能</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
              <td style={{ padding: '12px', fontWeight: 'bold' }}>返金・キャンセル</td>
              <td style={{ padding: '12px' }}>月の途中での解約・プラン変更時の日割り返金はございません。解約月末まで利用可能です。</td>
            </tr>
          </tbody>
        </table>

    <p style={{ marginTop: '30px', fontSize: '12px', color: '#64748b' }}>
          運営者: 冨岡 泰裕<br />
          制定日: 2025年12月25日
        </p>
      </div>
      
      <button className="close-button" onClick={() => setShowTerms(false)} style={{ marginTop: '20px' }}>
        閉じる
      </button>
    </div>
  </div>
)}

{/* 特定商取引法モーダル */}
{showTokuho && (
  <div className="message-overlay" onClick={() => setShowTokuho(false)}>
    <div className="message-box" onClick={(e) => e.stopPropagation()} style={{ maxHeight: '80vh', overflowY: 'auto' }}>
      <h2 style={{ marginBottom: '20px' }}>特定商取引法に基づく表記</h2>
      
      <div style={{ textAlign: 'left', fontSize: '14px', lineHeight: '1.8' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <tbody>
            <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold', width: '30%' }}>サービス名</td>
  <td style={{ padding: '12px' }}>SOERU（ソエル）</td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>事業者名</td>
  <td style={{ padding: '12px' }}>SOERU 運営事務局</td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>運営責任者</td>
  <td style={{ padding: '12px' }}>冨岡 泰裕</td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>所在地</td>
  <td style={{ padding: '12px' }}>長崎県佐世保市<br />※請求があった場合には、遅滞なく開示いたします。</td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>電話番号</td>
  <td style={{ padding: '12px' }}>※請求があった場合には、遅滞なく開示いたします。</td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>メールアドレス</td>
  <td style={{ padding: '12px' }}>leefria1119@hotmail.com</td>
</tr>
       <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>販売価格</td>
  <td style={{ padding: '12px' }}>
    無料お試しプラン: 0円<br />
    ベーシックプラン: 490円/月（税込）<br />
    バリュープラン: 980円/月（税込）
  </td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>追加手数料</td>
  <td style={{ padding: '12px' }}>なし</td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>支払方法</td>
  <td style={{ padding: '12px' }}>クレジットカード（Stripe）</td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>支払時期</td>
  <td style={{ padding: '12px' }}>有料プラン登録時即時決済、以降毎月自動更新</td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>サービス提供時期</td>
  <td style={{ padding: '12px' }}>決済完了後、即時利用可能</td>
</tr>
<tr style={{ borderBottom: '1px solid #e5e7eb' }}>
  <td style={{ padding: '12px', fontWeight: 'bold' }}>返金・キャンセル</td>
  <td style={{ padding: '12px' }}>
    月の途中での解約・プラン変更時の日割り返金はございません。<br />
    解約日まで利用可能です。
  </td>
</tr>
          </tbody>
        </table>
        
        <p style={{ marginTop: '30px', fontSize: '12px', color: '#64748b' }}>
          制定日: 2025年12月26日
        </p>
      </div>
      
      <button className="close-button" onClick={() => setShowTokuho(false)} style={{ marginTop: '20px' }}>
        閉じる
     </button>
    </div>
  </div>
)}
      </div>
    </div>
  );
}

export default App;